/* Basics Life Dawn Cart Drawer v17 - dynamic admin offer rules via Shopify Metaobjects */
(function () {
  if (window.__BL_CART_DRAWER_V11_CONFETTI_INIT__) return;
  window.__BL_CART_DRAWER_V11_CONFETTI_INIT__ = true;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  // === SALE catalog pre-fetch (warm cache) ====================================
  // /collections/sales/products.json is slow (~1-3s per page even at limit=50)
  // and the SALE collection has ~6,300 products across 26 pages at limit=250.
  // Instead of waiting on cart-open, we pre-fetch a strategic sample of pages
  // on page load and cache. Cart-open then renders the unlock section instantly
  // from the cached pool.
  //
  // Sample pages chosen to span the full PRICE_ASC range:
  //   limit=50, 126 pages total → sample 16 evenly across.
  // 16 × ~250ms = ~2-3s background fetch (capped by browser HTTP/2 concurrency).
  var SALE_PREFETCH_PAGES = [1, 8, 16, 24, 32, 40, 48, 56, 64, 72, 80, 88, 96, 108, 118, 126];
  var SALE_CACHE_KEY = 'blSaleCacheV2';
  var SALE_CACHE_TTL_MS = 30 * 60 * 1000;  // 30 min — catalog changes slowly
  var __saleCachePromise = null;

  function __trimSaleProduct(p) {
    var img = '';
    if (p.images && p.images[0]) {
      img = (typeof p.images[0] === 'string') ? p.images[0] : (p.images[0].src || '');
    } else if (typeof p.featured_image === 'string') {
      img = p.featured_image;
    }
    return {
      // 2026-05-27: /collections/{handle}/products.json does NOT return a `url`
      // field (unlike /recommendations/products.json), so p.url was undefined →
      // Complete-the-Look links pointed nowhere / fell through to a collection.
      // Derive the canonical product URL from the handle.
      id: p.id, handle: p.handle, title: p.title, url: p.url || ('/products/' + p.handle),
      featured_image: img,
      product_type: p.product_type || '',
      tags: p.tags || [],
      options: p.options,
      variants: (p.variants || []).map(function (v) {
        return {
          id: v.id, title: v.title,
          option1: v.option1, option2: v.option2, option3: v.option3,
          available: !!v.available, price: v.price,
          compare_at_price: v.compare_at_price
        };
      })
    };
  }

  // ===== Complete-the-Look (CEO spec v2: tier-aware cross-sell) ===============
  // Tab 6 category preferences: when cart has X, suggest these target categories
  // in priority order. Normalised to alphanumeric-only uppercase for matching.
  var CTL_CATEGORY_PREFS = {
    'SHIRTS':   ['TSHIRTS', 'TROUSERS', 'JEANS'],
    'TROUSERS': ['SHIRTS', 'TSHIRTS', 'JEANS'],
    'JEANS':    ['TSHIRTS', 'SHIRTS', 'SHORTS'],
    'TSHIRTS':  ['SHORTS', 'JEANS'],
    'SHORTS':   ['TSHIRTS'],
    'JACKET':   ['SHIRTS', 'TSHIRTS', 'TROUSERS']
  };
  // Tab 4 cross-category size mapping (top size → bottom size, bidirectional).
  var CTL_TOP_TO_BOTTOM = { 'XS':'28','S':'30','M':'32','L':'34','XL':'36','XXL':'38','XXXL':'40' };
  var CTL_BOTTOM_TO_TOP = {};
  Object.keys(CTL_TOP_TO_BOTTOM).forEach(function (k) { CTL_BOTTOM_TO_TOP[CTL_TOP_TO_BOTTOM[k]] = k; });
  var CTL_TOP_CATS    = { 'SHIRTS':1, 'TSHIRTS':1, 'JACKET':1 };
  var CTL_BOTTOM_CATS = { 'TROUSERS':1, 'JEANS':1, 'SHORTS':1 };

  function ctlNormCat(s) {
    return String(s || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  }
  function ctlIsTop(cat)    { return !!CTL_TOP_CATS[cat]; }
  function ctlIsBottom(cat) { return !!CTL_BOTTOM_CATS[cat]; }

  // Given the customer's cart sizes (set) and a target category, return the
  // size pool (as a Set of uppercase strings) to look for in target products.
  // Top→top: exact. Top→bottom or bottom→top: via mapping (±1 size tried as
  // edge-case fallback). If no signal, return null (no size filter).
  function ctlTargetSizesFor(cartTopSizes, cartBottomSizes, targetCat) {
    var out = {};
    if (ctlIsTop(targetCat)) {
      cartTopSizes.forEach(function (s) { out[s] = 1; });
      cartBottomSizes.forEach(function (s) {
        var m = CTL_BOTTOM_TO_TOP[s];
        if (m) out[m] = 1;
      });
    } else if (ctlIsBottom(targetCat)) {
      cartBottomSizes.forEach(function (s) { out[s] = 1; });
      cartTopSizes.forEach(function (s) {
        var m = CTL_TOP_TO_BOTTOM[s];
        if (m) out[m] = 1;
      });
    } else {
      cartTopSizes.forEach(function (s) { out[s] = 1; });
      cartBottomSizes.forEach(function (s) { out[s] = 1; });
    }
    return Object.keys(out).length ? out : null;
  }
  // ===== end Complete-the-Look helpers ========================================

  function __readSaleCache() {
    try {
      var raw = sessionStorage.getItem(SALE_CACHE_KEY);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || !obj.ts || !Array.isArray(obj.products)) return null;
      if ((Date.now() - obj.ts) > SALE_CACHE_TTL_MS) return null;
      return obj.products;
    } catch (e) { return null; }
  }

  function __writeSaleCache(products) {
    try {
      sessionStorage.setItem(SALE_CACHE_KEY, JSON.stringify({ ts: Date.now(), products: products }));
    } catch (e) { /* quota — skip */ }
  }

  // Returns a Promise resolving to the SALE product pool. Uses cache when fresh.
  // Multiple callers share the same in-flight Promise (deduped).
  function prefetchSale() {
    if (__saleCachePromise) return __saleCachePromise;
    var cached = __readSaleCache();
    if (cached && cached.length) {
      __saleCachePromise = Promise.resolve(cached);
      return __saleCachePromise;
    }
    // 27 Oct (#12/#14): the 16 pages were asked all at once, and Shopify answered "429 too many requests" on 230
    // visits in 6 days (Diwali week), so those drawers lost their Sale picks. Now: 4 pages at a time, stop at the
    // first 429, keep what arrived, and after a 429 do not ask again for 10 minutes in this tab.
    var __S429 = 'blSale429';
    try { var _t429 = +sessionStorage.getItem(__S429) || 0; if (_t429 && Date.now() - _t429 < 10 * 60 * 1000) { __saleCachePromise = Promise.resolve([]); return __saleCachePromise; } } catch (e) {}
    var __hit429 = false, __results = [];
    var __getPage = function (page) {
      return fetch('/collections/sales/products.json?limit=50&page=' + page, {
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      }).then(function (r) { if (r.status === 429) __hit429 = true; return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    };
    var __batches = [];
    for (var _b = 0; _b < SALE_PREFETCH_PAGES.length; _b += 4) __batches.push(SALE_PREFETCH_PAGES.slice(_b, _b + 4));
    __saleCachePromise = __batches.reduce(function (chain, batch) {
      return chain.then(function () {
        if (__hit429) return;
        return Promise.all(batch.map(__getPage)).then(function (rs) { __results = __results.concat(rs); });
      });
    }, Promise.resolve()).then(function () {
      if (__hit429) { try { sessionStorage.setItem(__S429, String(Date.now())); } catch (e) {} }
      var all = [];
      __results.forEach(function (r) { if (r && r.products) all = all.concat(r.products); });
      var trimmed = all.map(__trimSaleProduct);
      if (trimmed.length) __writeSaleCache(trimmed);
      return trimmed;
    }).catch(function () { return []; });
    return __saleCachePromise;
  }

  // Lazy prefetch: defer to whichever happens first —
  //   (a) browser idle callback (typically a few hundred ms after main render)
  //   (b) 4 seconds wall-clock (fallback for browsers without requestIdleCallback)
  //   (c) the first cart-drawer open (handled in renderUnlockSection: cold cache
  //       shows "Finding products…" then calls prefetchSale() inline)
  // Eager prefetch on every page load was hammering the network (16 parallel
  // /collections/sales/products.json calls), competing with the main page
  // render. Deferring keeps page load fast; users who never open the cart
  // never pay the prefetch cost.
  // 2026-05-29: skip eager prefetch on non-shopping pages. /pages/stores, account,
  // search, sitemap, etc. don't need 8-10MB of sale products prefetched — the
  // cart drawer's renderUnlockSection does an inline fetch on first open anyway.
  var __SKIP_PREFETCH_PATHS = /^\/(pages\/(stores|sitemap|gmc-landing|design-bento)|account|search|policies|cart\/?)/i;
  if (typeof window !== 'undefined' && typeof fetch === 'function' && !__SKIP_PREFETCH_PATHS.test(window.location.pathname || '')) {
    var __prefetchKicked = false;
    function __kickPrefetch() {
      if (__prefetchKicked) return;
      __prefetchKicked = true;
      try { prefetchSale(); } catch (e) {}
    }
    // 2026-10-06 (Clarity problem 8, slow product pages): on a PRODUCT page the 16 Sale pages (~650 KB) were
    // fetched while the phone was still loading the product photos. There, wait for a sign of buying — a tap on
    // a size / Add to cart (any pointerdown inside a cart form) — or 15 s after the page has loaded, whichever is
    // first. The drawer's own cold-cache path ("Finding products…") still covers an early open. Other pages: unchanged.
    if (/^\/products\//.test(window.location.pathname || '')) {
      var __onIntent = function (e) {
        var t = e && e.target;
        if (t && t.closest && t.closest('form[action*="/cart/add"], [name="add"], .product-form, variant-radios, variant-selects')) {
          document.removeEventListener('pointerdown', __onIntent, true);
          __kickPrefetch();
        }
      };
      document.addEventListener('pointerdown', __onIntent, true);
      var __later = function () { setTimeout(__kickPrefetch, 15000); };
      if (document.readyState === 'complete') __later(); else window.addEventListener('load', __later);
    } else if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(__kickPrefetch, { timeout: 4000 });
    } else {
      setTimeout(__kickPrefetch, 4000);
    }
  }
  // === end SALE catalog pre-fetch =============================================

  ready(function () {
    var root = document.getElementById('blCartDrawerRoot');
    if (!root) return;

    var panel = root.querySelector('.bl-cartdrawer__panel');
    var title = root.querySelector('.bl-cartdrawer__title');
    var itemsWrap = root.querySelector('.bl-cartdrawer__items');
    var emptyWrap = root.querySelector('.bl-cartdrawer__empty');
    var savingsWrap = root.querySelector('.bl-cartdrawer__savings');
    var savingsAmount = root.querySelector('.bl-cartdrawer__savings-amount');
    var savingsPercent = root.querySelector('.bl-cartdrawer__savings-percent');
    var nudgeWrap = root.querySelector('.bl-cartdrawer__nudge');
    var subtotalPrice = root.querySelector('.bl-cartdrawer__subtotal-price');
    var subtotalRow   = root.querySelector('.bl-cartdrawer__summary-row--subtotal');
    var discountRow = root.querySelector('.bl-cartdrawer__summary-row--discount');
    var discountPrice = root.querySelector('.bl-cartdrawer__discount-price');
    var totalPrice = root.querySelector('.bl-cartdrawer__summary-price');
    var totalCompare = root.querySelector('.bl-cartdrawer__summary-compare');
    var deliveryText = root.querySelector('.bl-cartdrawer__summary-delivery');
    var benefitsWrap = root.querySelector('.bl-cartdrawer__benefits');
    var warningWrap = root.querySelector('.bl-cartdrawer__warning');
    var checkoutBtn = root.querySelector('.bl-cartdrawer__checkout');
    var checkoutPay = root.querySelector('.bl-cartdrawer__checkout-pay');
    var checkoutTitle = root.querySelector('.bl-cartdrawer__checkout-title');
    var noteWrap = root.querySelector('.bl-cartdrawer__note');
    var confettiLayer = root.querySelector('.bl-cartdrawer__confetti-layer');
    var offersWrap = root.querySelector('.bl-cartdrawer__offers');
    var offerHeadline = root.querySelector('.bl-cartdrawer__offer-headline');
    var offerProgress = root.querySelector('.bl-cartdrawer__offer-progress');
    var offerMarkers = root.querySelector('.bl-cartdrawer__offer-markers');
    var offerSteps = root.querySelector('.bl-cartdrawer__offer-steps');
    var offerNote = root.querySelector('.bl-cartdrawer__offer-note');
    var offerQualifier = root.querySelector('.bl-cartdrawer__offer-qualifier');

    var config = {
      cartUrl: root.dataset.cartUrl || '/cart',
      cartAddUrl: root.dataset.cartAddUrl || '/cart/add',
      cartChangeUrl: (root.dataset.cartChangeUrl || '/cart/change').replace(/\.js$/, ''),
      cartJsonUrl: root.dataset.cartJsonUrl || '/cart.js',
      checkoutUrl: root.dataset.checkoutUrl || '/checkout',
      cartTitle: root.dataset.cartTitle || 'Review your order',
      deliveryText: root.dataset.deliveryText || 'Get it by Tue–Thu',
      benefits: (root.dataset.benefits || '').split('|').filter(Boolean),
      warningText: root.dataset.warningText || '',
      checkoutTitle: root.dataset.checkoutTitle || 'Checkout',
      checkoutNote: root.dataset.checkoutNote || '',
      offerEnabled: String(root.dataset.offerEnabled || '').toLowerCase() === 'true',
      offerTag: normalizeTag(root.dataset.offerTag || 'SALE'),
      offerTiers: parseOfferTiers(root.dataset.offerTiers || ''),
      offerRules: parseOfferRules(root.dataset.offerTiers || '', root.dataset.offerTag || 'SALE'),
     
      offerNote: root.dataset.offerNote || '',
      offerQualifierLabel: root.dataset.offerQualifierLabel || '',
      offerZeroMessage: root.dataset.offerZeroMessage || 'Add SALE products to unlock extra offers'
    };

    var state = {
      cart: null,
      fetchRequestId: 0,
      lastFocused: null,
      autoOpenTimer: null,
      internalAddActive: false,
      changingCart: false,
      compareAtByVariantId: Object.create(null),
      inventoryByVariantId: Object.create(null),
      inventoryTrackedByVariantId: Object.create(null),
      productTagsByHandle: Object.create(null),
      compareHandlePromiseByHandle: Object.create(null),
      lastCelebratedTierIndex: -1
    };

    function normalizeTag(tag) {
      return String(tag || '').trim().toUpperCase();
    }

    function parseOfferTiers(raw) {
      return String(raw || '')
        .split('|')
        .map(function (entry) {
          var parts = entry.split(':');
          if (parts.length < 2) return null;
          var threshold = Math.round(parseFloat(parts[0]) * 100);
          var discount = Math.round(parseFloat(parts[1]) * 100);
          if (!threshold || !discount) return null;
          return { threshold: threshold, discount: discount };
        })
        .filter(Boolean)
        .sort(function (a, b) { return a.threshold - b.threshold; });
    }

    function getOfferRulesJsonFromLiquid() {
      var script = document.getElementById('blCartOfferRulesJson');
      if (!script) return [];
      try {
        var parsed = JSON.parse(script.textContent || '[]');
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        return [];
      }
    }

    function normalizeOfferRule(raw, index) {
      raw = raw || {};
      var conditionType = String(raw.conditionType || raw.condition_type || 'spend').toLowerCase().trim();
      if (conditionType !== 'quantity') conditionType = 'spend';

      var rewardType = String(raw.rewardType || raw.reward_type || 'amount_off').toLowerCase().trim();
      if (['amount', 'fixed', 'fixed_amount'].indexOf(rewardType) > -1) rewardType = 'amount_off';
      if (['percent', 'percentage'].indexOf(rewardType) > -1) rewardType = 'percent_off';
      if (['bogo', 'buy_x_get_y', 'buyxgety'].indexOf(rewardType) > -1) rewardType = 'free_item';
      if (['free', 'free_product'].indexOf(rewardType) > -1) rewardType = 'free_item';
      if (['rs1', 'rs_1', 'one_rupee'].indexOf(rewardType) > -1) rewardType = 'rs1_item';

      var conditionValueRaw = Number(raw.conditionValue != null ? raw.conditionValue : raw.condition_value);
      var rewardValueRaw = Number(raw.rewardValue != null ? raw.rewardValue : raw.reward_value);
      var rewardQtyRaw = Number(raw.rewardQty != null ? raw.rewardQty : raw.reward_qty);

      var conditionValue = conditionType === 'quantity'
        ? Math.max(0, Math.floor(conditionValueRaw || 0))
        : Math.max(0, Math.round((conditionValueRaw || 0) * 100));

      var rewardValue = (rewardType === 'amount_off' || rewardType === 'rs1_item')
        ? Math.max(0, Math.round((rewardValueRaw || 0) * 100))
        : Math.max(0, rewardValueRaw || 0);

      var tag = normalizeTag(raw.tag || raw.productTag || raw.product_tag || 'SALE');
      var group = String(raw.group || raw.offerGroup || raw.offer_group || '').trim();
      if (!group) group = tag + '-' + conditionType + '-' + rewardType;

      if (!conditionValue) return null;
      if ((rewardType === 'amount_off' || rewardType === 'percent_off') && !rewardValue) return null;
      if ((rewardType === 'free_item' || rewardType === 'rs1_item') && !rewardQtyRaw) rewardQtyRaw = 1;
      if (rewardType === 'rs1_item' && !rewardValue) rewardValue = 100;

      return {
        id: String(raw.id || raw.handle || group + '-' + index),
        title: String(raw.title || ''),
        group: group,
        tag: tag,
        conditionType: conditionType,
        threshold: conditionValue,
        conditionValue: conditionValue,
        rewardType: rewardType,
        rewardValue: rewardValue,
        rewardQty: Math.max(0, Math.floor(rewardQtyRaw || 0)),
        label: String(raw.label || ''),
        couponCode: String(raw.couponCode || raw.coupon_code || ''),
        priority: Number(raw.priority || index || 0)
      };
    }

    function parseOfferRules(fallbackTiers, fallbackTag) {
      var dynamicRules = getOfferRulesJsonFromLiquid()
        .map(function (rule, index) {
          rule = rule || {};
          if (!rule.tag && !rule.productTag && !rule.product_tag) rule.tag = fallbackTag || 'SALE';
          return normalizeOfferRule(rule, index);
        })
        .filter(Boolean);

      if (dynamicRules.length) {
        return dynamicRules.sort(function (a, b) {
          if (a.group !== b.group) return a.priority - b.priority;
          return a.threshold - b.threshold;
        });
      }

      return parseOfferTiers(fallbackTiers).map(function (tier, index) {
        return normalizeOfferRule({
          group: 'sale-spend-amount',
          tag: fallbackTag || 'SALE',
          conditionType: 'spend',
          conditionValue: tier.threshold / 100,
          rewardType: 'amount_off',
          rewardValue: tier.discount / 100,
          label: 'Get Extra ' + formatMoney(tier.discount),
          priority: index + 1
        }, index);
      }).filter(Boolean);
    }

    function getItemTags(item) {
      var handle = getProductHandleFromItem(item);
      return state.productTagsByHandle[handle] || [];
    }

    function itemHasOfferTag(item, tag) {
      var tags = getItemTags(item);
      return tags.indexOf(normalizeTag(tag)) > -1;
    }

    function getUnitPrice(item) {
      var qty = Math.max(1, Number(item && item.quantity) || 1);
      var finalLine = Number(item && item.final_line_price || 0);
      return Math.max(0, Math.round(finalLine / qty));
    }

    function getQualifyingMetrics(cart, tag) {
      var subtotal = 0;
      var qty = 0;
      var unitPrices = [];
      getRenderableItems(cart).forEach(function (item) {
        if (!itemHasOfferTag(item, tag)) return;
        var itemQty = Math.max(0, Number(item && item.quantity) || 0);
        var qualifyingLine = Number(item && item.original_line_price || 0);
        if (qualifyingLine <= 0) qualifyingLine = Number(item && item.final_line_price || 0);
        subtotal += qualifyingLine;
        qty += itemQty;
        var unit = getUnitPrice(item);
        for (var i = 0; i < itemQty; i += 1) unitPrices.push(unit);
      });
      unitPrices.sort(function (a, b) { return a - b; });
      return { subtotal: subtotal, qty: qty, unitPrices: unitPrices };
    }

    function estimateRuleDiscount(rule, metrics) {
      if (!rule || !metrics) return 0;
      if (rule.rewardType === 'amount_off') return Math.min(Number(rule.rewardValue || 0), Number(metrics.subtotal || 0));
      if (rule.rewardType === 'percent_off') return Math.round(Number(metrics.subtotal || 0) * (Number(rule.rewardValue || 0) / 100));
      if (rule.rewardType === 'free_item') {
        var freeQty = Math.max(1, Number(rule.rewardQty || 1));
        return metrics.unitPrices.slice(0, freeQty).reduce(function (sum, price) { return sum + Number(price || 0); }, 0);
      }
      if (rule.rewardType === 'rs1_item') {
        var rsQty = Math.max(1, Number(rule.rewardQty || 1));
        var rsPrice = Math.max(0, Number(rule.rewardValue || 100));
        return metrics.unitPrices.slice(0, rsQty).reduce(function (sum, price) {
          return sum + Math.max(0, Number(price || 0) - rsPrice);
        }, 0);
      }
      return 0;
    }

    function formatRuleCondition(rule) {
      if (!rule) return '';
      if (rule.conditionType === 'quantity') return 'Buy ' + String(rule.threshold);
      return formatMoney(rule.threshold);
    }

    function formatRuleReward(rule) {
      if (!rule) return '';
      if (rule.label) return rule.label;
      if (rule.rewardType === 'amount_off') return 'Get ' + formatMoney(rule.rewardValue);
      if (rule.rewardType === 'percent_off') return 'Get ' + Number(rule.rewardValue || 0) + '%';
      if (rule.rewardType === 'free_item') {
        var qty = Math.max(1, Number(rule.rewardQty || 1));
        return qty === 1 ? 'Get 1 Free' : 'Get ' + qty + ' Free';
      }
      if (rule.rewardType === 'rs1_item') return 'Rs.1';
      return 'Offer';
    }

    // Format a tier reward. Previously appended a "(N%)" suffix derived from
    // rewardValue / threshold (so "Get Extra ₹2,500" became "Get Extra ₹2,500 (31%)").
    // Removed per user request 2026-05-25 — the % was misleading (% of what?) and
    // visually noisy in the tier nudge. Just show the absolute reward amount.
    function formatRuleRewardWithPct(rule) {
      return formatRuleReward(rule);
    }

    function normalizeUrl(url) {
      try {
        return new URL(url, window.location.origin).pathname;
      } catch (e) {
        return String(url || '');
      }
    }

    function isCartAddUrl(url) {
      return /\/cart\/add(\.js)?$/.test(normalizeUrl(url && url.url ? url.url : url));
    }

    function getShopRoot() {
      return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    }

    function getProductHandleFromItem(item) {
      var rawUrl = String((item && item.url) || '');
      var match = rawUrl.match(/\/products\/([^\/?#]+)/);
      return match ? match[1] : '';
    }

    function getCachedCompareAt(item) {
      var variantId = String(item && (item.variant_id || item.id) || '');
      var compareAt = Number(state.compareAtByVariantId[variantId] || 0);
      return compareAt > 0 ? compareAt : 0;
    }

    function getLineCompareTotal(item) {
      var quantity = Math.max(1, Number(item && item.quantity) || 1);
      var finalLinePrice = Number(item && item.final_line_price || 0);
      var compareAt = getCachedCompareAt(item);
      if (compareAt > 0) {
        var compareLine = compareAt * quantity;
        if (compareLine > finalLinePrice) return compareLine;
      }
      var originalLine = Number(item && item.original_line_price || 0);
      if (originalLine > finalLinePrice) return originalLine;
      return 0;
    }

    function getRenderableItems(cart) {
      return (cart && Array.isArray(cart.items) ? cart.items : []).filter(function (item) {
        return Number(item && item.quantity) > 0;
      });
    }

    function calculateBaseSavings(cart) {
      var items = getRenderableItems(cart);
      var compareBasedSavings = items.reduce(function (sum, item) {
        var compareLine = getLineCompareTotal(item);
        var finalLine = Number(item && item.final_line_price || 0);
        return sum + Math.max(0, compareLine - finalLine);
      }, 0);
      var cartLevelSavings = Math.max(0, Number(cart && cart.original_total_price || 0) - Number(cart && cart.total_price || 0));
      return Math.max(compareBasedSavings, cartLevelSavings);
    }

    function calculateOfferInfo(cart) {
      var rules = (config.offerRules || []).filter(Boolean);
      if (!config.offerEnabled || !rules.length) {
        return {
          enabled: false,
          qualifyingSubtotal: 0,
          qualifyingQty: 0,
          currentValue: 0,
          discount: 0,
          payableTotal: Number(cart && cart.total_price || 0),
          subtotal: Number(cart && cart.total_price || 0),
          nextTier: null,
          activeTier: null,
          progressPercent: 0,
          remaining: 0,
          hasQualifyingItems: false,
          tiers: []
        };
      }

      var subtotal = Number(cart && cart.total_price || 0);
      var groups = Object.create(null);
      rules.forEach(function (rule) {
        var key = rule.group || (rule.tag + '-' + rule.conditionType + '-' + rule.rewardType);
        if (!groups[key]) groups[key] = [];
        groups[key].push(rule);
      });

      var best = null;
      Object.keys(groups).forEach(function (key) {
        var tiers = groups[key].slice().sort(function (a, b) { return a.threshold - b.threshold; });
        var firstRule = tiers[0];
        var metrics = getQualifyingMetrics(cart, firstRule.tag);
        var currentValue = firstRule.conditionType === 'quantity' ? metrics.qty : metrics.subtotal;
        var hasQualifyingItems = metrics.qty > 0 || metrics.subtotal > 0;
        var activeTier = null;
        var nextTier = null;

        tiers.forEach(function (tier) {
          if (currentValue >= tier.threshold) activeTier = tier;
          if (!nextTier && currentValue < tier.threshold) nextTier = tier;
        });

        var highestThreshold = tiers.length ? tiers[tiers.length - 1].threshold : 0;
        var progressPercent = highestThreshold > 0 ? Math.max(0, Math.min(100, (currentValue / highestThreshold) * 100)) : 0;
        var discount = activeTier ? estimateRuleDiscount(activeTier, metrics) : 0;

        var groupInfo = {
          enabled: true,
          group: key,
          tag: firstRule.tag,
          conditionType: firstRule.conditionType,
          qualifyingSubtotal: metrics.subtotal,
          qualifyingQty: metrics.qty,
          currentValue: currentValue,
          discount: discount,
          payableTotal: Math.max(0, subtotal - discount),
          subtotal: subtotal,
          nextTier: nextTier,
          activeTier: activeTier,
          progressPercent: progressPercent,
          remaining: nextTier ? Math.max(0, nextTier.threshold - currentValue) : 0,
          hasQualifyingItems: hasQualifyingItems,
          tiers: tiers
        };

        if (!best) {
          best = groupInfo;
          return;
        }

        if (groupInfo.hasQualifyingItems && !best.hasQualifyingItems) {
          best = groupInfo;
          return;
        }
        if (groupInfo.hasQualifyingItems === best.hasQualifyingItems && groupInfo.progressPercent > best.progressPercent) {
          best = groupInfo;
        }
      });

      return best || {
        enabled: false,
        qualifyingSubtotal: 0,
        qualifyingQty: 0,
        currentValue: 0,
        discount: 0,
        payableTotal: subtotal,
        subtotal: subtotal,
        nextTier: null,
        activeTier: null,
        progressPercent: 0,
        remaining: 0,
        hasQualifyingItems: false,
        tiers: []
      };
    }

    function fetchProductCompareData(handle) {
      if (!handle) return Promise.resolve();
      if (state.compareHandlePromiseByHandle[handle]) return state.compareHandlePromiseByHandle[handle];

      var url = getShopRoot() + 'products/' + encodeURIComponent(handle) + '.js';
      state.compareHandlePromiseByHandle[handle] = fetch(url, {
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Product fetch failed');
          return response.json();
        })
        .then(function (product) {
          if (product && Array.isArray(product.variants)) {
            product.variants.forEach(function (variant) {
              var id = String(variant && variant.id || '');
              var compareAt = Number(variant && variant.compare_at_price || 0);
              if (id && compareAt > 0) state.compareAtByVariantId[id] = compareAt;
              // NOTE: Shopify's public products.json does NOT expose
              // inventory_quantity. Stock validation has to be done server-side
              // by /cart/change.js — we surface its error message via toast.
            });
          }
          var tags = [];
          if (product) {
            if (Array.isArray(product.tags)) {
              tags = product.tags.map(normalizeTag);
            } else if (typeof product.tags === 'string') {
              tags = product.tags.split(',').map(normalizeTag);
            }
          }
          state.productTagsByHandle[handle] = tags.filter(Boolean);
        })
        .catch(function () {
          state.productTagsByHandle[handle] = state.productTagsByHandle[handle] || [];
        })
        .finally(function () {
          state.compareHandlePromiseByHandle[handle] = null;
        });

      return state.compareHandlePromiseByHandle[handle];
    }

    function hydrateProductMeta(cart) {
      var items = getRenderableItems(cart);
      var handles = [];
      var seen = Object.create(null);

      items.forEach(function (item) {
        var handle = getProductHandleFromItem(item);
        if (!handle || seen[handle]) return;
        seen[handle] = true;
        handles.push(handle);
      });

      if (!handles.length) return Promise.resolve();
      return Promise.all(handles.map(fetchProductCompareData)).catch(function () {});
    }

    // Toast helper — used for stock alerts and other transient cart messages.
    // Renders above the cart drawer, auto-dismisses after 3.5s.
    function blCartToast(message, type) {
      var existing = document.getElementById('bl-cart-toast');
      if (existing) existing.remove();
      var el = document.createElement('div');
      el.id = 'bl-cart-toast';
      el.className = 'bl-cart-toast' + (type === 'error' ? ' is-error' : '');
      el.textContent = message;
      document.body.appendChild(el);
      setTimeout(function () {
        if (!el.parentNode) return;
        el.style.opacity = '0';
        setTimeout(function () { if (el.parentNode) el.remove(); }, 250);
      }, 3500);
    }

    function formatMoney(cents) {
      var value = Number(cents || 0) / 100;
      try {
        return new Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency: 'INR',
          maximumFractionDigits: value % 1 === 0 ? 0 : 2,
          minimumFractionDigits: value % 1 === 0 ? 0 : 2
        }).format(value);
      } catch (e) {
        var fixed = value.toFixed(2);
        if (fixed.endsWith('.00')) fixed = fixed.slice(0, -3);
        return '₹' + fixed;
      }
    }

    function escapeHtml(str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    // Mirrors snippets/bcl-clean-title.liquid — strips "Basics " brand prefix
    // and "{Fit} Fit " phrases. Keep this in sync with the Liquid version.
    function cleanProductTitle(t) {
      if (t == null) return '';
      var s = String(t);
      s = s.split('Basics ').join('').split('BASICS ').join('').split('basics ').join('');
      var fits = ['Slim Fit ','Tapered Fit ','Regular Fit ','Relaxed Fit ','Comfort Fit ','Muscle Fit ','Skinny Fit ','Super Skinny Fit ','Drift Fit ','Torque Fit ','Blade Fit ','Kerb Fit '];
      for (var i = 0; i < fits.length; i++) {
        var f = fits[i];
        s = s.split(f).join('').split(f.toLowerCase()).join('').split(f.toUpperCase()).join('');
      }
      return s.trim().replace(/  /g, ' ').replace(/  /g, ' ');
    }


    function clearConfetti() {
      if (!confettiLayer) return;
      confettiLayer.innerHTML = '';
      confettiLayer.classList.remove('is-active');
    }

    function playCartConfettiBurst() {
      if (!confettiLayer) return;
      clearConfetti();
      confettiLayer.classList.add('is-active');

      var colors = ['#ff5f5f', '#ffbf3f', '#38c172', '#3b82f6', '#a855f7', '#14b8a6'];
      var pieces = [];
      for (var i = 0; i < 64; i += 1) {
        var left = Math.random() * 100;
        var drift = (Math.random() * 140) - 70;
        var delay = Math.random() * 0.32;
        var duration = 1.7 + (Math.random() * 0.9);
        var rotate = (Math.random() * 540) - 270;
        var size = 5 + Math.random() * 7;
        var color = colors[i % colors.length];
        pieces.push(
          '<span class="bl-cartdrawer__confetti-piece" style="left:' + left + '%;--bl-confetti-drift:' + drift + 'px;--bl-confetti-delay:' + delay.toFixed(2) + 's;--bl-confetti-duration:' + duration.toFixed(2) + 's;--bl-confetti-rotate:' + rotate.toFixed(0) + 'deg;--bl-confetti-size:' + size.toFixed(1) + 'px;--bl-confetti-color:' + color + ';"></span>'
        );
      }
      confettiLayer.innerHTML = pieces.join('');
      window.clearTimeout(playCartConfettiBurst._timer);
      playCartConfettiBurst._timer = window.setTimeout(function () {
        clearConfetti();
      }, 3200);
    }

    function maybeCelebrateTier(activeIndex) {
      // Confetti celebration disabled 2026-05-23 per user request.
      // Tier index tracking kept so other logic that depends on
      // state.lastCelebratedTierIndex doesn't break.
      if (activeIndex < 0) {
        state.lastCelebratedTierIndex = -1;
        return;
      }
      if (activeIndex !== state.lastCelebratedTierIndex) {
        state.lastCelebratedTierIndex = activeIndex;
      }
    }

    function updateCartCount(count) {
      count = Number(count || 0);

      // Warehouse custom count support
      document.querySelectorAll('.header__cart-count').forEach(function (el) {
        el.textContent = String(count);
      });

      // Dawn cart bubble support
      document.querySelectorAll('#cart-icon-bubble, a.header__icon--cart').forEach(function (cartLink) {
        if (!cartLink) return;
        var bubble = cartLink.querySelector('.cart-count-bubble');

        if (count <= 0) {
          if (bubble) bubble.remove();
          return;
        }

        if (!bubble) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
          cartLink.appendChild(bubble);
        }

        var visual = bubble.querySelector('span[aria-hidden="true"]') || bubble.querySelector('span');
        var hidden = bubble.querySelector('.visually-hidden');
        if (visual) visual.textContent = count < 100 ? String(count) : '';
        if (hidden) hidden.textContent = count + ' item' + (count === 1 ? '' : 's') + ' in cart';
      });
    }

    function setButtonsBusy(isBusy) {
      root.querySelectorAll('.bl-cartdrawer__qty-btn, .bl-cartdrawer__remove').forEach(function (el) {
        el.disabled = !!isBusy;
      });
      if (checkoutBtn) {
        checkoutBtn.disabled = !!isBusy;
      }
    }

    function openDrawer() {
      state.lastFocused = document.activeElement;
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('bl-cartdrawer-lock');
      document.body.classList.add('bl-cartdrawer-lock');
      if (panel && typeof panel.focus === 'function') panel.focus();
    }

    // Direct overlay click → close. Belt-and-braces in case some script on
    // the page swallows the bubbled document-level click.
    (function bindOverlayClose() {
      var overlay = root.querySelector('.bl-cartdrawer__overlay');
      if (!overlay) return;
      overlay.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeDrawer();
      });
    })();
    // ESC closes the drawer (parity with the size + notify sub-modals)
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) {
        // If a sub-modal is open, ESC handlers there will close it first.
        var sizeOpen = root.querySelector('.bl-cartdrawer__size-modal.is-open');
        var notifyOpen = root.querySelector('.bl-cartdrawer__notify-modal.is-open');
        if (!sizeOpen && !notifyOpen) closeDrawer();
      }
    });

    function closeDrawer() {
      // Cascade-close any open sub-modals so closing the cart dismisses everything.
      var sizeM = root.querySelector('.bl-cartdrawer__size-modal.is-open');
      if (sizeM) sizeM.classList.remove('is-open');
      var notifyM = root.querySelector('.bl-cartdrawer__notify-modal.is-open');
      if (notifyM) notifyM.classList.remove('is-open');
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('bl-cartdrawer-lock');
      document.body.classList.remove('bl-cartdrawer-lock');
      if (state.lastFocused && typeof state.lastFocused.focus === 'function') {
        state.lastFocused.focus();
      }
    }

    function renderBenefits() {
      benefitsWrap.innerHTML = config.benefits.map(function (item) {
        return '<div class="bl-cartdrawer__benefit">' + escapeHtml(item) + '</div>';
      }).join('');
    }

    function getVariantText(item) {
      if (item.product_has_only_default_variant) return '';
      if (item.variant_title && item.variant_title !== 'Default Title') return item.variant_title;
      if (Array.isArray(item.options_with_values) && item.options_with_values.length) {
        return item.options_with_values.map(function (entry) {
          return entry.name + ': ' + entry.value;
        }).join(' / ');
      }
      return '';
    }

    function renderOfferSection(offerInfo) {
      if (!offersWrap) return;
      if (!offerInfo.enabled || !offerInfo.tiers.length) {
        offersWrap.hidden = true;
        offersWrap.classList.remove('is-unlocked', 'has-next-target');
        return;
      }

      offersWrap.hidden = false;

      var headline = '';
      var tagText = offerInfo.tag || config.offerTag || 'SALE';
      if (offerInfo.nextTier) {
        if (offerInfo.conditionType === 'quantity') {
          headline = 'Add ' + offerInfo.remaining + ' more ' + tagText + ' item' + (offerInfo.remaining > 1 ? 's' : '') + ' & ' + formatRuleRewardWithPct(offerInfo.nextTier);
        } else {
          headline = 'Spend ' + formatMoney(offerInfo.remaining) + ' more & ' + formatRuleRewardWithPct(offerInfo.nextTier);
        }
      } else if (offerInfo.activeTier) {
        headline = 'Target achieved · ' + formatRuleRewardWithPct(offerInfo.activeTier);
      } else if (offerInfo.hasQualifyingItems) {
        headline = 'Add more ' + tagText + ' products to unlock offer';
      } else {
        headline = config.offerZeroMessage;
      }
      offerHeadline.textContent = headline;

      var currentValue = Number(offerInfo.currentValue || 0);
      var activeIndex = -1;
      var nextIndex = -1;
      offerInfo.tiers.forEach(function (tier, index) {
        if (currentValue >= tier.threshold) activeIndex = index;
        if (nextIndex === -1 && currentValue < tier.threshold) nextIndex = index;
      });

      offersWrap.classList.toggle('is-unlocked', activeIndex > -1);
      offersWrap.classList.toggle('has-next-target', nextIndex > -1);
      maybeCelebrateTier(activeIndex);

      var count = offerInfo.tiers.length;
      if (offerSteps) offerSteps.style.setProperty('--bl-offer-step-count', String(Math.max(1, count)));
      var startLeft = 20;

      var endLeft = 94;
      var markerPositions = offerInfo.tiers.map(function (_tier, index) {
        if (count === 1) return 50;
        return startLeft + ((endLeft - startLeft) * index / (count - 1));
      });

      var progressWidth = 0;
      if (count === 1) {
        var firstThreshold = offerInfo.tiers[0].threshold || 1;
        progressWidth = Math.max(0, Math.min(100, (currentValue / firstThreshold) * 100)) * 0.88 + startLeft;
      } else if (currentValue <= 0) {
        progressWidth = 0;
      } else {
        var segmentIndex = 0;
        for (var i = 0; i < offerInfo.tiers.length; i += 1) {
          if (currentValue >= offerInfo.tiers[i].threshold) {
            segmentIndex = i;
          }
        }

        if (nextIndex === -1) {
          progressWidth = endLeft;
        } else if (segmentIndex === 0 && currentValue < offerInfo.tiers[0].threshold) {
          var firstRatio = Math.max(0, Math.min(1, currentValue / (offerInfo.tiers[0].threshold || 1)));
          progressWidth = startLeft + ((markerPositions[0] - startLeft) * firstRatio);
        } else {
          var previousThreshold = offerInfo.tiers[segmentIndex].threshold || 0;
          var nextThreshold = offerInfo.tiers[nextIndex].threshold || previousThreshold || 1;
          var span = Math.max(1, nextThreshold - previousThreshold);
          var ratio = Math.max(0, Math.min(1, (currentValue - previousThreshold) / span));
          progressWidth = markerPositions[segmentIndex] + ((markerPositions[nextIndex] - markerPositions[segmentIndex]) * ratio);
        }
      }
      offerProgress.style.width = Math.max(0, Math.min(endLeft, progressWidth)) + '%';

      offerMarkers.innerHTML = offerInfo.tiers.map(function (tier, index) {
        var left = markerPositions[index];
        var classes = ['bl-cartdrawer__offer-marker'];
        if (index < activeIndex) classes.push('is-achieved');
        if (index === activeIndex) classes.push('is-current-achieved');
        if (index === nextIndex) classes.push('is-next');
        return [
          '<div class="', classes.join(' '), '" style="left:', left, '%">',
            '<div class="bl-cartdrawer__offer-marker-value">', escapeHtml(formatRuleCondition(tier)), '</div>',
            '<div class="bl-cartdrawer__offer-marker-dot"></div>',
          '</div>'
        ].join('');
      }).join('');

      offerSteps.innerHTML = offerInfo.tiers.map(function (tier, index) {
        var classes = ['bl-cartdrawer__offer-step'];
        var text = formatRuleRewardWithPct(tier);
        if (index < activeIndex) classes.push('is-achieved');
        if (index === activeIndex) {
          classes.push('is-current-achieved');
          // Just show the reward + %, no "Applied" badge — current state is
          // implicit from the highlighted class.
          return '<div class="' + classes.join(' ') + '">' + escapeHtml(text) + '</div>';
        } else if (index === nextIndex) {
          classes.push('is-next');
        }
        return '<div class="' + classes.join(' ') + '">' + escapeHtml(text) + '</div>';
      }).join('');

      offerNote.textContent = config.offerNote;
      offerQualifier.textContent = config.offerQualifierLabel;

      // RELOCATION (2026-05-23): the old "Spend ₹X more & Get Extra ₹Y" headline
      // and the row of tier step labels ("Get Extra ₹800 (20%) …") have been
      // replaced. The nudge text now sits ABOVE the progress bar, and the
      // savings banner sits BELOW it. Both are populated here and the originals
      // in the footer are hidden in renderItems().
      // Headline element is left blank — its content will be set by renderItems()
      // after the nudge text is computed.
      offerHeadline.innerHTML = '';
      // Steps element is left blank — savings banner content will be set by
      // renderItems() after savings are computed.
      offerSteps.innerHTML = '';
    }

    function renderItems(cart) {
      var visibleItems = getRenderableItems(cart);
      var visibleItemCount = visibleItems.reduce(function (sum, item) {
        return sum + Number(item.quantity || 0);
      }, 0);
      var offerInfo = calculateOfferInfo(cart);
      state.lastOfferInfo = offerInfo;
      var baseSavings = calculateBaseSavings(cart);
      // SUBTOTAL = sum of natural sale prices = sum of item.original_line_price.
      // This equals "After (product-level) discount" in the user's spreadsheet — ₹4,337
      // for the 3-item example. Shopify's cart.items_subtotal_price *should* equal
      // this same number, but if any line has a Shopify Function/Script that re-
      // calculates line totals, items_subtotal_price might reflect the post-discount
      // value. Safer to compute from item.original_line_price directly.
      var lineSubtotal = (cart.items || []).reduce(function (s, it) {
        return s + Number(it.original_line_price || (it.price * it.quantity) || 0);
      }, 0);
      var subtotal      = lineSubtotal;
      var displayTotal  = Number(cart && cart.total_price || 0);
      // OFFER DISCOUNT = tier reward applied at cart level. Compute as the gap
      // between natural-sale subtotal and Shopify's authoritative final total —
      // that way it always equals what the customer actually saves at checkout,
      // regardless of whether the discount source is a Shopify automatic discount,
      // Shopify Script, Function, or our own offerInfo calc.
      var offerDiscount = Math.max(0, subtotal - displayTotal);
      // TOTAL SAVINGS = MRP - final, plain and simple. baseSavings is computed
      // as Σ(compare_at × qty − final_line_price), which ALREADY reflects every
      // discount applied (product-level + tier reward) — adding offerDiscount on
      // top would double-count the tier reward (e.g., ₹4,080 base savings became
      // ₹5,580 with the ₹1,500 tier reward erroneously added a second time).
      var totalSavings        = baseSavings;
      var summaryCompareTotal = offerDiscount > 0 ? subtotal : (displayTotal + baseSavings);

      title.textContent = config.cartTitle + ' (' + visibleItemCount + ')';
      deliveryText.textContent = config.deliveryText;
      warningWrap.textContent = config.warningText;
      checkoutTitle.textContent = config.checkoutTitle;
      noteWrap.textContent = config.checkoutNote;
      updateCartCount(visibleItemCount);

      renderOfferSection(offerInfo);

      if (totalSavings > 0) {
        savingsWrap.hidden = false;
        savingsAmount.textContent = formatMoney(totalSavings);
        if (savingsPercent) {
          // % savings = totalSavings ÷ MRP total (sum of compare_at × qty for all
          // visible items). Using MRP_total as the denominator (instead of
          // savings + final) gives the true "% off MRP" — which matches what
          // customers expect when they see strikethrough MRP next to each item.
          // When Shopify line-level discounts adjust item.price below the natural
          // sale price, (savings + displayTotal) underestimates MRP, so the %
          // showed higher than the per-item compare-at % off (was 48 instead of 47).
          var mrpTotal = (cart.items || []).reduce(function (s, it) {
            return s + getLineCompareTotal(it);
          }, 0);
          var pct = mrpTotal > 0 ? Math.round((totalSavings / mrpTotal) * 100) : 0;
          savingsPercent.textContent = pct > 0 ? '(' + pct + '%)' : '';
        }
      } else {
        savingsWrap.hidden = true;
      }

      // ── Nudge: shows the customer that adding more SALE products DROPS
      //    the cart total (buy more, pay less). Computes the exact net drop
      //    when the next tier is reachable in money terms:
      //      netDrop = (nextTierDiscount − currentTierDiscount) − remainingSpend
      //    If netDrop > 0, the customer literally pays LESS for MORE items.
      if (nudgeWrap) {
        if (offerInfo && offerInfo.nextTier) {
          var nextTierReward = Number(offerInfo.nextTier.rewardValue || 0);
          var currentTierReward = offerInfo.activeTier ? Number(offerInfo.activeTier.rewardValue || 0) : 0;
          var rewardDelta = nextTierReward - currentTierReward;

          if (offerInfo.conditionType === 'quantity') {
            // Quantity-based tier — we can't compute money drop precisely
            // because we don't know the price of the next item the customer
            // would add. Fall back to the encouraging message.
            var qtyRem = offerInfo.remaining + ' more SALE item' + (offerInfo.remaining > 1 ? 's' : '');
            nudgeWrap.innerHTML = 'Add <strong>' + qtyRem + '</strong> to unlock <strong>' + escapeHtml(formatRuleRewardWithPct(offerInfo.nextTier)) + '</strong> — your total drops further (buy more, pay less!).';
          } else {
            // Money-based tier. Two messages:
            //  (a) Strong "DROPS by ₹X" — when the strict formula proves it
            //      (next-tier reward − remaining > 0).
            //  (b) Soft "may DROP further" — for the more common case where
            //      the strict formula is negative, but per-line discount
            //      redistribution at the next tier typically still nets out
            //      to lower pay (verified empirically: e.g. spending ₹810
            //      more often drops the bill by ~₹200 once the tier flips).
            var remSpend = Number(offerInfo.remaining || 0);
            var netDrop = rewardDelta - remSpend;
            var nextRewardTxt = escapeHtml(formatRuleRewardWithPct(offerInfo.nextTier));
            if (netDrop > 0) {
              nudgeWrap.innerHTML =
                'Spend <strong>' + formatMoney(remSpend) + '</strong> more on SALE products and your total <strong>DROPS by ' + formatMoney(netDrop) + '</strong> — you get more items for less money.';
            } else {
              nudgeWrap.innerHTML =
                'Spend <strong>' + formatMoney(remSpend) + '</strong> more on SALE products to unlock <strong>' + nextRewardTxt + '</strong> — your per-item price <strong>DROPS further</strong> (buy more, pay less!).';
            }
          }
          nudgeWrap.hidden = false;
        } else if (offerInfo && offerInfo.activeTier && offerInfo.hasQualifyingItems) {
          nudgeWrap.innerHTML = 'You’ve unlocked the top tier.';
          nudgeWrap.hidden = false;
        } else if (offerInfo && !offerInfo.hasQualifyingItems) {
          nudgeWrap.innerHTML = 'Add <strong>SALE</strong>-tagged products — the more you add, the lower your per-unit price drops.';
          nudgeWrap.hidden = false;
        } else {
          nudgeWrap.hidden = true;
        }
      }

      // Mirror nudge → offer-headline (above progress bar) and savings →
      // offer-steps (below progress bar). Hide the originals in the footer.
      if (offerHeadline) {
        if (nudgeWrap && !nudgeWrap.hidden) {
          offerHeadline.innerHTML = nudgeWrap.innerHTML;
          offerHeadline.style.display = '';
        } else {
          offerHeadline.innerHTML = '';
          offerHeadline.style.display = 'none';
        }
      }
      if (offerSteps) {
        if (savingsWrap && !savingsWrap.hidden) {
          var savingsAmt = savingsAmount ? savingsAmount.textContent : '';
          var savingsPct = savingsPercent ? savingsPercent.textContent : '';
          offerSteps.innerHTML =
            'You saved <strong>' + escapeHtml(savingsAmt) + '</strong> ' +
            (savingsPct ? '<span class="bl-cartdrawer__offer-savings-pct">' + escapeHtml(savingsPct) + '</span> ' : '') +
            'on this order';
          offerSteps.style.display = '';
        } else {
          offerSteps.innerHTML = '';
          offerSteps.style.display = 'none';
        }
      }
      // Hide the original footer instances now that they're shown up top.
      if (nudgeWrap) nudgeWrap.hidden = true;
      if (savingsWrap) savingsWrap.hidden = true;

      subtotalPrice.textContent = formatMoney(subtotal);
      if (offerDiscount > 0) {
        // Show the breakdown: SUBTOTAL (sum of items at natural sale price)
        // → OFFER DISCOUNT (-tier reward) → TOTAL AMOUNT (final checkout amount).
        // Without showing SUBTOTAL, the customer can't see WHY the total is less
        // than what they see on each item card.
        if (subtotalRow) subtotalRow.hidden = false;
        discountRow.hidden = false;
        discountPrice.textContent = '- ' + formatMoney(offerDiscount);
        totalCompare.hidden = false;
        totalCompare.textContent = formatMoney(summaryCompareTotal);
      } else {
        if (subtotalRow) subtotalRow.hidden = true;
        discountRow.hidden = true;
        if (baseSavings > 0) {
          totalCompare.hidden = false;
          totalCompare.textContent = formatMoney(summaryCompareTotal);
        } else {
          totalCompare.hidden = true;
          totalCompare.textContent = '';
        }
      }

      totalPrice.textContent = formatMoney(displayTotal);
      checkoutPay.textContent = '/ ' + formatMoney(displayTotal);

      if (!visibleItems.length) {
        itemsWrap.innerHTML = '';
        emptyWrap.hidden = false;
        offersWrap.hidden = true;
        checkoutBtn.disabled = true;
        checkoutBtn.style.pointerEvents = 'none';
        checkoutBtn.style.opacity = '0.6';
        return;
      }

      emptyWrap.hidden = true;
      checkoutBtn.disabled = false;
      checkoutBtn.style.pointerEvents = '';
      checkoutBtn.style.opacity = '';

      // Distribute the tier-level offer discount proportionally across the
      // SALE-qualifying line items so each line's displayed price reflects
      // what the customer is actually paying for that item. Without this,
      // line prices show the pre-tier-rebate price (e.g. ₹1,699 each) while
      // checkout shows the post-rebate total (e.g. ₹2,598) — confusing.
      // After distribution, sum(line prices) === displayTotal exactly.
      var effectiveLinePrices = {};
      if (offerDiscount > 0) {
        var qualifyingItemsForDist = visibleItems.filter(function (it) {
          return itemHasOfferTag(it, config.offerTag);
        });
        var qualifyingTotalForDist = qualifyingItemsForDist.reduce(function (sum, it) {
          return sum + Number(it.final_line_price || 0);
        }, 0);
        if (qualifyingTotalForDist > 0) {
          var allocated = 0;
          qualifyingItemsForDist.forEach(function (it, idx) {
            var lineFinal = Number(it.final_line_price || 0);
            var alloc;
            if (idx === qualifyingItemsForDist.length - 1) {
              // Last line gets the remainder — guarantees exact sum.
              alloc = Math.max(0, offerDiscount - allocated);
            } else {
              alloc = Math.round((lineFinal / qualifyingTotalForDist) * offerDiscount);
              allocated += alloc;
            }
            effectiveLinePrices[it.key] = Math.max(0, lineFinal - alloc);
          });
        }
      }
      function getEffectiveLinePrice(it) {
        if (effectiveLinePrices.hasOwnProperty(it.key)) return effectiveLinePrices[it.key];
        return Number(it.final_line_price || 0);
      }

      itemsWrap.innerHTML = visibleItems.map(function (item) {
        var variantText = getVariantText(item);
        var compareLinePrice = getLineCompareTotal(item);
        // Per-item display = Shopify's FINAL_LINE_PRICE = the all-in price the
        // customer pays per line AFTER both the product-level discount AND the
        // cart-level tier-reward distributed share. E.g., MRP ₹999 → 30% sale
        // ₹699 → 18.4% tier-rebate share ₹128.97 → final ₹570.33.
        // The bottom "SUBTOTAL → OFFER DISCOUNT → TOTAL" breakdown explains
        // the math: items_subtotal_price (₹4,337 = sum of natural sale prices)
        // minus total_discount (₹800 tier reward) = total_price (₹3,537 final).
        // Display per-item shows FINAL because that's what the customer pays for
        // that specific item — the breakdown below explains how it got there.
        var displayPrice = Number(item.final_line_price || (item.price * item.quantity) || 0);
        var compareHtml = '';
        if (compareLinePrice > 0 && compareLinePrice > displayPrice) {
          var lineDiscountPct = Math.round((1 - displayPrice / compareLinePrice) * 100);
          compareHtml =
            '<div class="bl-cartdrawer__compare">' + formatMoney(compareLinePrice) + '</div>' +
            '<div class="bl-cartdrawer__discount-pct">' + lineDiscountPct + '% off</div>';
        } else if (compareLinePrice > 0) {
          compareHtml = '<div class="bl-cartdrawer__compare">' + formatMoney(compareLinePrice) + '</div>';
        }
        var effectivePrice = displayPrice;  // legacy alias for downstream code below
        var imageUrl = item.featured_image && item.featured_image.url
          ? item.featured_image.url + '&width=220'
          : (item.image || '');

        // Stock check now happens server-side via /cart/change.js — Shopify
        // returns a 422 with a helpful description ("You can only add 2 of
        // this item to your cart") which we surface via toast in updateByKey.
        var plusAttrs = '';

        return [
          '<div class="bl-cartdrawer__item" data-key="', escapeHtml(item.key), '">',
            '<a class="bl-cartdrawer__image-wrap" href="', escapeHtml(item.url || '#'), '">',
              imageUrl ? '<img src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' : '',
            '</a>',
            '<div class="bl-cartdrawer__content">',
              '<a class="bl-cartdrawer__name" href="', escapeHtml(item.url || '#'), '">', escapeHtml(cleanProductTitle(item.product_title)), '</a>',
              variantText ? '<p class="bl-cartdrawer__variant">' + escapeHtml(variantText) + '</p>' : '',
              '<div class="bl-cartdrawer__qty">',
                '<button type="button" class="bl-cartdrawer__qty-btn" data-qty-action="minus" aria-label="Decrease quantity">−</button>',
                '<span class="bl-cartdrawer__qty-value">', String(item.quantity), '</span>',
                '<button type="button" class="bl-cartdrawer__qty-btn" data-qty-action="plus" aria-label="Increase quantity"' + plusAttrs + '>+</button>',
              '</div>',
            '</div>',
            '<div class="bl-cartdrawer__side">',
              '<button type="button" class="bl-cartdrawer__remove" data-remove-item aria-label="Remove item">',
                '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">',
                  '<polyline points="3 6 5 6 21 6"></polyline>',
                  '<path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>',
                  '<path d="M10 11v6"></path>',
                  '<path d="M14 11v6"></path>',
                  '<path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"></path>',
                '</svg>',
              '</button>',
              '<div class="bl-cartdrawer__price-block">',
                '<div class="bl-cartdrawer__price">', formatMoney(effectivePrice), '</div>',
                compareHtml,
              '</div>',
            '</div>',
          '</div>'
        ].join('');
      }).join('');
    }

    function setLoading(message) {
      emptyWrap.hidden = true;
      itemsWrap.innerHTML = '<div class="bl-cartdrawer__loading">' + escapeHtml(message || 'Loading...') + '</div>';
    }

    // Populate "You may also like" using Shopify's recommendations endpoint,
    // seeded with the first cart item's product_id. Section stays hidden if
    // the API returns no products.
    // Renders either:
    //   (a) the "Unlock ₹X off — Add ₹Y more" upsell — when a next money tier
    //       is reachable. Fetches SALE products priced ≥ remaining, sorted
    //       ascending, with an inline size-picker on each + button click.
    //   (b) the generic "You may also like" — when top tier reached, or for
    //       quantity-based tiers (where money-filtering doesn't apply).
    function renderRecommended(cart) {
      var recWrap = root.querySelector('.bl-cartdrawer__rec');
      var recRow  = root.querySelector('.bl-cartdrawer__rec-row');
      var recTitle = recWrap ? recWrap.querySelector('.bl-cartdrawer__rec-title') : null;
      if (!recWrap || !recRow || !recTitle) return;
      var items = getRenderableItems(cart);
      if (!items.length) { recWrap.hidden = true; return; }

      var oi = state.lastOfferInfo;
      var hasMoneyNextTier = oi && oi.nextTier && oi.conditionType !== 'quantity' && Number(oi.remaining) > 0;
      if (hasMoneyNextTier) {
        renderUnlockSection(oi, items, recWrap, recRow, recTitle);
      } else {
        renderYouMayAlsoLikeSection(cart, items, recWrap, recRow, recTitle);
      }
    }

    function renderYouMayAlsoLikeSection(cart, items, recWrap, recRow, recTitle) {
      var seedProductId = items[0].product_id || items[0].productId;
      if (!seedProductId) { recWrap.hidden = true; return; }
      recTitle.textContent = 'You may also like';
      fetch('/recommendations/products.json?product_id=' + encodeURIComponent(seedProductId) + '&limit=6&intent=related', {
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data || !data.products || !data.products.length) return;
          var cartHandles = items.map(function (it) { return it.handle; }).filter(Boolean);
          // Filter out items already in cart AND any product with no in-stock variant.
          // ALSO: /recommendations/products.json returns prices in PAISE (e.g., 269900 for
          // ₹2,699), while unlockCardHtml expects RUPEES (the format Shopify storefront
          // /collections/{handle}/products.json uses). Divide every variant price by 100
          // so the cards render with the correct money values, not 100× too large.
          var recs = data.products.filter(function (p) {
            if (cartHandles.indexOf(p.handle) !== -1) return false;
            var variants = p.variants || [];
            return variants.some(function (v) { return v.available; });
          }).slice(0, 6).map(function (p) {
            var cloned = Object.assign({}, p);
            cloned.variants = (p.variants || []).map(function (v) {
              var nv = Object.assign({}, v);
              nv.price = Number(v.price) / 100;
              if (v.compare_at_price != null) nv.compare_at_price = Number(v.compare_at_price) / 100;
              return nv;
            });
            return cloned;
          });
          if (!recs.length) return;
          recRow.innerHTML = recs.map(unlockCardHtml).join('');
          recWrap.hidden = false;
          bindUnlockHandlers(recRow);
        })
        .catch(function () {});
    }

    // CEO spec v2: "Complete the Look" — tier-aware cross-sell.
    //   1. Gap = next_tier - SALE subtotal (already in oi.remaining)
    //   2. From cart items, collect sizes + categories
    //   3. Pull candidates from preference-mapped target categories (Tab 6)
    //   4. Filter by size availability (top→top exact, top↔bottom mapped per Tab 4)
    //   5. Filter by gap-derived price band (Tab 3): single-item bridges to tier
    //   6. Rank: stock health → low price (proxy for best-seller within SALE pool)
    //   7. Diversify: max 2 per product_type. Take top 4.
    //   8. Microcopy per card: "Add to unlock ₹X off → effective ₹Y"
    // Cart math / tier rewards are untouched — this only changes what's *suggested*.
    function renderUnlockSection(oi, items, recWrap, recRow, recTitle) {
      var remainingPaise  = Number(oi.remaining || 0);
      var remainingRupees = Math.ceil(remainingPaise / 100);
      var rewardPaise     = Number(oi.nextTier.rewardValue || 0);

      // Gap-to-price-band (Tab 3). All amounts in rupees.
      var bandLow, bandHigh;
      if (remainingRupees < 200) {
        bandLow = 500;  bandHigh = 900;          // overshoot, gentle nudge
      } else if (remainingRupees > 2000) {
        bandLow = 500;  bandHigh = 1000;         // multi-item path: show low-priced items
      } else {
        bandLow = remainingRupees;
        bandHigh = remainingRupees + 500;        // direct cross: ~match gap
      }
      // Broader fallback if strict band has no in-size matches.
      var fallbackLow  = Math.max(300, remainingRupees - 200);
      var fallbackHigh = remainingRupees + 1000;

      recTitle.textContent = 'Complete the look';

      var cachedNow = __readSaleCache();
      if (cachedNow) {
        recWrap.hidden = false;
        processProducts(cachedNow);
      } else {
        recRow.innerHTML = '<div class="bl-cartdrawer__rec-loading">Finding products…</div>';
        recWrap.hidden = false;
        prefetchSale().then(processProducts).catch(function () {
          renderUnlockFallbackCta(oi, items, recWrap, recRow, recTitle);
        });
      }

      function minAvailPrice(p) {
        return Math.min.apply(null, (p.variants || [])
          .filter(function (v) { return v.available; })
          .map(function (v) { return Number(v.price) || Infinity; }));
      }
      function stockHealth(p) {
        return (p.variants || []).filter(function (v) { return v.available; }).length;
      }

      // Split cart sizes into top-vs-bottom buckets so we can map across systems.
      function getCartSizesByAxis(cartItems) {
        var topSizes = {}, bottomSizes = {}, cats = {};
        (cartItems || []).forEach(function (item) {
          var pt = ctlNormCat(item.product_type || '');
          if (pt) cats[pt] = 1;
          var isBottom = ctlIsBottom(pt);
          var owv = item.options_with_values || [];
          owv.forEach(function (ov) {
            if (String(ov.name || '').toLowerCase().trim() !== 'size' || !ov.value) return;
            var v = String(ov.value).toUpperCase().trim();
            if (isBottom) bottomSizes[v] = 1;
            else topSizes[v] = 1;
          });
        });
        return {
          topSizes: Object.keys(topSizes),
          bottomSizes: Object.keys(bottomSizes),
          cats: Object.keys(cats)
        };
      }

      function productAvailableInSizes(product, sizeSet) {
        if (!sizeSet) return true;
        var sizeIdx = findSizeOptionIndex(product);
        var sizeKey = ['option1', 'option2', 'option3'][sizeIdx] || 'option1';
        return (product.variants || []).some(function (v) {
          if (!v.available) return false;
          return sizeSet[String(v[sizeKey] || '').toUpperCase().trim()] === 1;
        });
      }

      function processProducts(products) {
        var cartHandles = items.map(function (it) { return it.handle; }).filter(Boolean);
        var cartInfo = getCartSizesByAxis(items);

        // Resolve target categories from cart cats. Preserves Tab 6 priority order;
        // de-dup; if cart has no recognised cat, fall back to "any category".
        var targetCats = [];
        cartInfo.cats.forEach(function (c) {
          var prefs = CTL_CATEGORY_PREFS[c];
          if (!prefs) return;
          prefs.forEach(function (t) {
            if (targetCats.indexOf(t) === -1) targetCats.push(t);
          });
        });
        var hasTargetFilter = targetCats.length > 0;

        // Bucket candidates: (a) in strict band + target cat + size match, (b) fallback band.
        var primary = [], fallback = [], seen = {};
        (products || []).forEach(function (p) {
          if (seen[p.id]) return;
          if (cartHandles.indexOf(p.handle) !== -1) return;
          var availVariants = (p.variants || []).filter(function (v) { return v.available; });
          if (availVariants.length < 2) return;       // Tab 1: hide < 2 units available
          var price = minAvailPrice(p);
          if (!isFinite(price)) return;
          var pCat = ctlNormCat(p.product_type || '');
          if (hasTargetFilter && targetCats.indexOf(pCat) === -1) return;
          var sizeSet = ctlTargetSizesFor(cartInfo.topSizes, cartInfo.bottomSizes, pCat);
          if (!productAvailableInSizes(p, sizeSet)) return;

          if (price >= bandLow && price <= bandHigh) {
            primary.push(p); seen[p.id] = 1;
          } else if (price >= fallbackLow && price <= fallbackHigh) {
            fallback.push(p); seen[p.id] = 1;
          }
        });

        var pool = primary.length ? primary : fallback;
        if (!pool.length) {
          renderUnlockSizeMismatchCta(oi, cartInfo.topSizes.concat(cartInfo.bottomSizes), recWrap, recRow, items, recTitle);
          return;
        }

        // Tie-breaker (Tab 5, simplified — all are SALE since pool comes from
        // /collections/sales): stock health desc, then price asc (cheaper =
        // easier to add, lower bar to cross the tier).
        pool.sort(function (a, b) {
          var sa = stockHealth(a), sb = stockHealth(b);
          if (sa !== sb) return sb - sa;
          return minAvailPrice(a) - minAvailPrice(b);
        });

        // Diversify: max 2 per product_type, take top 4.
        var perCat = {}, picked = [];
        for (var i = 0; i < pool.length && picked.length < 4; i++) {
          var c = ctlNormCat(pool[i].product_type || '');
          var n = perCat[c] || 0;
          if (n >= 2) continue;
          perCat[c] = n + 1;
          picked.push(pool[i]);
        }
        if (!picked.length) picked = pool.slice(0, 4);

        // Per-card microcopy: only show "unlock" line when adding THIS item
        // actually crosses the next tier (price >= gap). This obeys Tab 3's
        // "don't promise what won't deliver" rule.
        recRow.innerHTML = picked.map(function (p) {
          var price = minAvailPrice(p);
          var crosses = price >= remainingRupees && rewardPaise > 0;
          var microcopy = '';
          if (crosses) {
            var effective = Math.max(0, price - Math.round(rewardPaise / 100));
            microcopy = 'Add to unlock ' + formatMoney(rewardPaise) + ' off → effective ' + formatMoney(effective * 100);
          }
          return unlockCardHtml(p, microcopy);
        }).join('');
        recWrap.hidden = false;
        bindUnlockHandlers(recRow);
      }
    }

    // Fallback when no product matches BOTH the price band AND a cart size:
    // show "You may also like" recommendations instead of the empty CTA card.
    // The CTA card was a dead end — bouncing the customer to /collections — while
    // YMA gives them shoppable suggestions inside the drawer.
    function renderUnlockSizeMismatchCta(oi, userSizes, recWrap, recRow, items, recTitle) {
      renderYouMayAlsoLikeSection(null, items, recWrap, recRow, recTitle);
    }

    // Same idea — when no SALE products priced in the unlock band exist,
    // fall through to "You may also like" rather than a CTA card.
    function renderUnlockFallbackCta(oi, items, recWrap, recRow, recTitle) {
      renderYouMayAlsoLikeSection(null, items, recWrap, recRow, recTitle);
    }

    // Returns 0/1/2 — which position in the variant options array is the
    // "Size" option. Falls back to 0 if no option is named Size.
    function findSizeOptionIndex(product) {
      var opts = product.options || [];
      for (var i = 0; i < opts.length; i++) {
        var name = String((opts[i] && opts[i].name) || opts[i] || '').toLowerCase().trim();
        if (name === 'size') return i;
      }
      // If only one option exists (just "Size", just "Color", etc.), use it.
      return 0;
    }

    // Storefront /collections/{handle}/products.json returns images as objects
    // ({id, src, ...}), not plain URL strings. featured_image is absent.
    function productImageSrc(product) {
      if (!product) return '';
      if (typeof product.featured_image === 'string') return product.featured_image;
      var imgs = product.images || [];
      var first = imgs[0];
      if (!first) return '';
      if (typeof first === 'string') return first;
      return first.src || '';
    }

    // Storefront /collections/X/products.json returns tags as Array;
    // /recommendations/products.json returns tags as a comma-separated String.
    // Normalise to a case-insensitive contains check.
    function blProductHasTag(product, tagName) {
      if (!product || !product.tags) return false;
      var needle = String(tagName).toUpperCase();
      if (Array.isArray(product.tags)) {
        return product.tags.some(function (t) { return String(t).toUpperCase() === needle; });
      }
      return String(product.tags).split(',').some(function (t) {
        return t.trim().toUpperCase() === needle;
      });
    }

    function unlockCardHtml(product, microcopy) {
      var img = productImageSrc(product);
      var titleEsc = escapeHtml(product.title || '');
      var titleCleanEsc = escapeHtml(cleanProductTitle(product.title));
      // Use the cheapest AVAILABLE variant (if any) to derive both the now-price
      // and the MRP shown struck-through. Falls back to first variant if none
      // is available (defensive — shouldn't happen since we filter upstream).
      var availPool = (product.variants || []).filter(function (v) { return v.available; });
      var pool = availPool.length ? availPool : (product.variants || []);
      pool = pool.slice().sort(function (a, b) { return Number(a.price) - Number(b.price); });
      var minVar = pool[0] || {};
      var price = Number(minVar.price || 0);
      var compareAt = Number(minVar.compare_at_price || 0);
      var hasDiscount = compareAt > price && price > 0;
      var discountPct = hasDiscount ? Math.round((1 - price / compareAt) * 100) : 0;

      // 2026-05-27: SALE/FRESH badges removed per merchant request.
      var badgeHtml = '';

      var priceHtml;
      if (hasDiscount) {
        priceHtml =
          '<div class="bl-cartdrawer__rec-price">' +
            '<span class="bl-cartdrawer__rec-price-now">' + formatMoney(price * 100) + '</span>' +
            '<span class="bl-cartdrawer__rec-price-mrp">' + formatMoney(compareAt * 100) + '</span>' +
            '<span class="bl-cartdrawer__rec-price-off">' + discountPct + '% off</span>' +
          '</div>';
      } else {
        priceHtml =
          '<div class="bl-cartdrawer__rec-price">' +
            '<span class="bl-cartdrawer__rec-price-now">' + formatMoney(price * 100) + '</span>' +
          '</div>';
      }

      var microHtml = (typeof microcopy === 'string' && microcopy)
        ? '<div class="bl-cartdrawer__rec-micro">' + escapeHtml(microcopy) + '</div>'
        : '';
      var sizeIdx = findSizeOptionIndex(product);
      var meta = JSON.stringify({
        title: product.title,
        url: product.url,
        image: img,
        sizeIdx: sizeIdx,
        variants: (product.variants || []).map(function (v) {
          return {
            id: v.id, title: v.title,
            option1: v.option1, option2: v.option2, option3: v.option3,
            available: !!v.available, price: v.price,
            compare_at_price: v.compare_at_price
          };
        })
      });
      return '<div class="bl-cartdrawer__rec-card" data-unlock-card data-product=\'' + escapeHtml(meta) + '\'>' +
        '<a href="' + escapeHtml(product.url) + '" class="bl-cartdrawer__rec-link">' +
          '<div class="bl-cartdrawer__rec-img">' +
            (img ? '<img src="' + escapeHtml(img) + '" alt="' + titleEsc + '" loading="lazy">' : '') +
            badgeHtml +
          '</div>' +
          '<div class="bl-cartdrawer__rec-name">' + titleCleanEsc + '</div>' +
          priceHtml +
          microHtml +
        '</a>' +
        '<button type="button" class="bl-cartdrawer__rec-add" data-unlock-toggle aria-label="Add to cart">+</button>' +
      '</div>';
    }

    function bindUnlockHandlers(recRow) {
      Array.from(recRow.querySelectorAll('[data-unlock-toggle]')).forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var card = btn.closest('[data-unlock-card]');
          if (!card) return;
          var raw = card.getAttribute('data-product');
          if (!raw) return;
          try {
            var prod = JSON.parse(raw);
            openSizeModal(prod);
          } catch (err) { /* swallow */ }
        });
      });
    }

    function openSizeModal(product) {
      // Lazy-build modal element on first use, then re-populate it each time.
      var modal = root.querySelector('.bl-cartdrawer__size-modal');
      if (!modal) {
        modal = document.createElement('div');
        modal.className = 'bl-cartdrawer__size-modal';
        modal.innerHTML =
          '<div class="bl-cartdrawer__size-modal-backdrop" data-cart-close-all></div>' +
          '<div class="bl-cartdrawer__size-modal-panel" role="dialog" aria-modal="true">' +
            '<button type="button" class="bl-cartdrawer__size-modal-close" data-size-close aria-label="Close">×</button>' +
            '<div class="bl-cartdrawer__size-modal-head">' +
              '<div class="bl-cartdrawer__size-modal-img"></div>' +
              '<div class="bl-cartdrawer__size-modal-meta">' +
                '<div class="bl-cartdrawer__size-modal-title"></div>' +
                '<div class="bl-cartdrawer__size-modal-price"></div>' +
              '</div>' +
            '</div>' +
            '<div class="bl-cartdrawer__size-modal-label">Select size</div>' +
            '<div class="bl-cartdrawer__size-modal-pills"></div>' +
          '</div>';
        root.appendChild(modal);
        modal.addEventListener('click', function (e) {
          if (!e.target) return;
          // Backdrop (tap outside the sheet) dismisses the whole cart drawer;
          // the × button just closes the size sheet and returns to the cart.
          if (e.target.hasAttribute('data-cart-close-all')) { closeDrawer(); return; }
          if (e.target.hasAttribute('data-size-close')) closeSizeModal();
        });
      }
      var imgWrap = modal.querySelector('.bl-cartdrawer__size-modal-img');
      var titleEl = modal.querySelector('.bl-cartdrawer__size-modal-title');
      var priceEl = modal.querySelector('.bl-cartdrawer__size-modal-price');
      var pillsEl = modal.querySelector('.bl-cartdrawer__size-modal-pills');

      var minPrice = Math.min.apply(null, product.variants.map(function (v) { return Number(v.price); }));
      imgWrap.innerHTML = product.image ? '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title || '') + '" loading="lazy">' : '';
      titleEl.textContent = product.title || '';
      priceEl.textContent = formatMoney(minPrice * 100);

      var sizeIdx = (typeof product.sizeIdx === 'number') ? product.sizeIdx : 0;
      var optKey = ['option1', 'option2', 'option3'][sizeIdx] || 'option1';
      // OOS sizes render greyed-out and inert — size label only, no "NOTIFY ME"
      // (matches the PDP size selector, where out-of-stock sizes are just faded).
      pillsEl.innerHTML = product.variants.map(function (v) {
        var lbl = v[optKey] || v.option1 || v.title || '';
        var avail = v.available;
        return '<button type="button" class="bl-cartdrawer__size-modal-pill' + (avail ? '' : ' is-unavailable') + '" ' +
          'data-variant-id="' + v.id + '" ' +
          'data-size-label="' + escapeHtml(lbl) + '"' +
          (avail ? '' : ' disabled aria-disabled="true"') +
          '>' +
            escapeHtml(lbl) +
          '</button>';
      }).join('');

      Array.from(pillsEl.querySelectorAll('.bl-cartdrawer__size-modal-pill')).forEach(function (pill) {
        pill.addEventListener('click', function () {
          // OOS pills are disabled/inert — nothing to do (no notify modal).
          if (pill.classList.contains('is-unavailable')) return;
          var variantId = pill.getAttribute('data-variant-id');
          if (!variantId) return;
          // Disable all pills while in flight
          Array.from(pillsEl.querySelectorAll('.bl-cartdrawer__size-modal-pill')).forEach(function (p) { p.disabled = true; });
          pill.classList.add('is-loading');
          fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
            body: 'id=' + encodeURIComponent(variantId) + '&quantity=1'
          })
            .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
            .then(function (res) {
              if (!res.ok) {
                blCartToast((res.data && res.data.description) || 'Could not add', 'error');
                Array.from(pillsEl.querySelectorAll('.bl-cartdrawer__size-modal-pill')).forEach(function (p) {
                  if (!p.classList.contains('is-unavailable')) p.disabled = false;
                });
                pill.classList.remove('is-loading');
                return;
              }
              closeSizeModal();
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              fetchCart(false);
            })
            .catch(function () {
              blCartToast('Network error', 'error');
              Array.from(pillsEl.querySelectorAll('.bl-cartdrawer__size-modal-pill')).forEach(function (p) {
                if (!p.classList.contains('is-unavailable')) p.disabled = false;
              });
              pill.classList.remove('is-loading');
            });
        });
      });

      modal.classList.add('is-open');
    }

    // NOTIFY ME sub-modal — opens when an OOS size pill is tapped. Mirrors the
    // PDP/PLP notify modals (same localStorage stash, same UX).
    function openNotifyModal(ctx) {
      var modal = root.querySelector('.bl-cartdrawer__notify-modal');
      if (!modal) {
        modal = document.createElement('div');
        modal.className = 'bl-cartdrawer__notify-modal';
        modal.innerHTML =
          '<div class="bl-cartdrawer__notify-backdrop" data-notify-close></div>' +
          '<div class="bl-cartdrawer__notify-panel" role="dialog" aria-modal="true">' +
            '<div class="bl-cartdrawer__notify-head">' +
              '<h3 class="bl-cartdrawer__notify-title">NOTIFY ME</h3>' +
              '<button type="button" class="bl-cartdrawer__notify-close" data-notify-close aria-label="Close">×</button>' +
            '</div>' +
            '<div class="bl-cartdrawer__notify-body">' +
              '<p class="bl-cartdrawer__notify-context">We’ll notify you when <strong data-notify-size-label>this size</strong> is back in stock.</p>' +
              '<form class="bl-cartdrawer__notify-form" data-notify-form>' +
                '<input type="hidden" data-notify-product value="">' +
                '<input type="hidden" data-notify-size value="">' +
                '<input type="email" name="email" placeholder="Email address" required>' +
                '<input type="tel" name="phone" placeholder="+91 Phone number" required pattern="[0-9+\\s\\-]{8,}">' +
                '<label class="bl-cartdrawer__notify-check">' +
                  '<input type="checkbox" name="marketing" value="1">' +
                  '<span>We’ll update you through our marketing channels.</span>' +
                '</label>' +
                '<button type="submit">NOTIFY ME</button>' +
              '</form>' +
            '</div>' +
          '</div>';
        root.appendChild(modal);
        modal.addEventListener('click', function (e) {
          if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-notify-close')) closeNotifyModal();
        });
        var form = modal.querySelector('[data-notify-form]');
        if (form) {
          form.addEventListener('submit', function (e) {
            e.preventDefault();
            var btn = form.querySelector('button[type=submit]');
            if (btn) { btn.disabled = true; btn.textContent = 'Saving…'; }
            try {
              var arr = JSON.parse(localStorage.getItem('bpdp_notify_requests') || '[]');
              var data = {
                email: form.querySelector('input[name=email]').value,
                phone: form.querySelector('input[name=phone]').value,
                marketing: form.querySelector('input[name=marketing]').checked ? '1' : '',
                product: form.querySelector('[data-notify-product]').value,
                size: form.querySelector('[data-notify-size]').value,
                source: 'bl-cart-drawer',
                created_at: new Date().toISOString()
              };
              arr.push(data);
              localStorage.setItem('bpdp_notify_requests', JSON.stringify(arr));
            } catch (err) {}
            setTimeout(function () {
              if (btn) btn.textContent = 'WE’LL NOTIFY YOU ✓';
              setTimeout(function () {
                closeNotifyModal();
                if (btn) { btn.disabled = false; btn.textContent = 'NOTIFY ME'; }
                form.reset();
              }, 1300);
            }, 320);
          });
        }
      }
      var sizeLbl = modal.querySelector('[data-notify-size-label]');
      var sizeInp = modal.querySelector('[data-notify-size]');
      var prodInp = modal.querySelector('[data-notify-product]');
      if (sizeLbl) sizeLbl.textContent = 'size ' + (ctx.size || '');
      if (sizeInp) sizeInp.value = ctx.size || '';
      if (prodInp) prodInp.value = ctx.productTitle || '';
      modal.classList.add('is-open');
    }
    function closeNotifyModal() {
      var modal = root.querySelector('.bl-cartdrawer__notify-modal');
      if (modal) modal.classList.remove('is-open');
    }

    function closeSizeModal() {
      var modal = root.querySelector('.bl-cartdrawer__size-modal');
      if (modal) modal.classList.remove('is-open');
    }

    function fetchCart(openAfter) {
      var requestId = ++state.fetchRequestId;
      setLoading('Loading your cart...');
      // 2026-06-01 PERF: when this fetch is meant to OPEN the drawer, open it
      // immediately (CSS, instant) and show the loading state inside instead of
      // waiting for the /cart.js round-trip to finish (was 1-3s perceived lag).
      if (openAfter) openDrawer();

      return fetch(config.cartJsonUrl, {
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart fetch failed');
          return response.json();
        })
        .then(function (cart) {
          if (requestId !== state.fetchRequestId) return;
          state.cart = cart;
          renderBenefits();
          renderItems(cart);
          setButtonsBusy(false);
          if (openAfter) openDrawer();
          document.dispatchEvent(new CustomEvent('bl:cart:updated', { detail: { cart: cart } }));

          hydrateProductMeta(cart).then(function () {
            if (requestId !== state.fetchRequestId) return;
            if (!state.cart) return;
            renderItems(state.cart);
            // Render "You may also like" after we've hydrated the first item
            // (so we have a product_id to base recommendations on).
            renderRecommended(state.cart);
          });
        })
        .catch(function () {
          if (requestId !== state.fetchRequestId) return;
          itemsWrap.innerHTML = '<div class="bl-cartdrawer__state">Unable to load cart right now.</div>';
          setButtonsBusy(false);
          if (openAfter) openDrawer();
        });
    }

    function updateByKey(key, quantity) {
      if (!key || state.changingCart) return Promise.resolve();
      state.changingCart = true;
      setButtonsBusy(true);

      var row = root.querySelector('.bl-cartdrawer__item[data-key="' + CSS.escape(String(key)) + '"]');
      if (row) {
        row.style.opacity = '0.45';
        row.style.pointerEvents = 'none';
      }

      // Snapshot the current qty + variant_id so we can detect Shopify
      // silently capping the requested quantity AND have a reliable
      // secondary key for post-update lookup (in case the line-item key
      // changes or doesn't round-trip cleanly through the data-key attribute).
      var prevQty = 0;
      var lineVariantId = null;
      if (state.cart && Array.isArray(state.cart.items)) {
        for (var i = 0; i < state.cart.items.length; i++) {
          if (String(state.cart.items[i].key) === String(key)) {
            prevQty = Number(state.cart.items[i].quantity) || 0;
            lineVariantId = String(state.cart.items[i].variant_id || state.cart.items[i].id || '');
            break;
          }
        }
      }
      var requestedQty = Number(quantity);
      var wasIncreasing = requestedQty > prevQty;

      function restoreRow() {
        if (row) {
          row.style.opacity = '';
          row.style.pointerEvents = '';
        }
      }

      return fetch(config.cartChangeUrl + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: String(key), quantity: requestedQty })
      })
        .then(function (response) {
          return response.json().then(function (body) {
            return { ok: response.ok, body: body };
          });
        })
        .then(function (res) {
          if (!res.ok) {
            // Shopify 422 error — payload: { description: "You can only add 2…" }
            var msg = (res.body && (res.body.description || res.body.message)) || 'Could not update cart';
            blCartToast(msg, 'error');
            restoreRow();
            return;
          }
          // Success — response IS the new cart. No extra /cart.js fetch needed,
          // which avoids the "Loading your cart..." flash.
          state.cart = res.body;
          renderBenefits();
          renderItems(res.body);
          // Re-render the unlock/YMA section too: when remaining changes (e.g.
          // user dropped a line), the title + product list must update to match
          // the new tier gap.
          renderRecommended(res.body);

          // Detect silent capping: we asked for +1 but the new qty is less
          // than requested (Shopify quietly clamped to available stock).
          //
          // Use a sentinel value (-1) for "not found" so we never show a
          // toast based on a default 0 (which previously caused a false
          // "Only 0 available" message when the lookup failed for reasons
          // unrelated to stock — e.g. key escaping mismatch). Match on
          // either key OR variant_id for resilience.
          if (wasIncreasing) {
            var actualQty = -1;
            for (var j = 0; j < res.body.items.length; j++) {
              var li = res.body.items[j];
              var keyMatch = String(li.key) === String(key);
              var vidMatch = lineVariantId && String(li.variant_id || li.id) === lineVariantId;
              if (keyMatch || vidMatch) {
                actualQty = Number(li.quantity) || 0;
                break;
              }
            }
            // Only show the cap toast when we actually located the line item
            // AND its post-update quantity is less than what was requested.
            if (actualQty >= 0 && actualQty < requestedQty) {
              blCartToast('Only ' + actualQty + ' available in this size', 'error');
            }
          }
        })
        .catch(function () {
          blCartToast('Network error — please try again', 'error');
          restoreRow();
        })
        .finally(function () {
          state.changingCart = false;
          setButtonsBusy(false);
        });
    }

    function findFormByFormId(button) {
      var formId = button && button.getAttribute && button.getAttribute('form');
      if (formId) return document.getElementById(formId);
      return null;
    }

    function findVisibleAddForm() {
      var forms = Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"], form[action^="/cart/add"]'));
      return forms.find(function (form) {
        var rect = form.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0;
      }) || forms[0] || null;
    }

    function findAddToCartForm(fromEl) {
      if (!fromEl) return null;
      var directForm = findFormByFormId(fromEl) || fromEl.closest('form');
      if (directForm) {
        var action = directForm.getAttribute('action') || '';
        if (/\/cart\/add/.test(action) || directForm.querySelector('[name="id"]')) return directForm;
      }
      var block = fromEl.closest('.product-form, .product-form__payment-container, .product-item, .product, .product__info-wrapper, .quick-add, .card, .shopify-section');
      if (block) {
        var nested = block.querySelector('form[action*="/cart/add"], form[action^="/cart/add"]');
        if (nested) return nested;
      }
      return findVisibleAddForm();
    }

    function addToCart(form, button) {
      if (!form || form.dataset.blCartSubmitting === '1') return Promise.resolve();

      var formData = new FormData(form);
      var submitButton = button || form.querySelector('[type="submit"]');
      var originalHtml = submitButton ? submitButton.innerHTML : '';

      form.dataset.blCartSubmitting = '1';
      state.internalAddActive = true;

      openDrawer();
      setLoading('Adding to cart...');

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.innerHTML = '<span class="bl-cartdrawer__spinner"></span>';
      }

      return fetch(config.cartAddUrl + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
        .then(function (response) {
          if (!response.ok) return response.json().then(function (err) { throw err; });
          return response.json();
        })
        .then(function () {
          return fetchCart(true);
        })
        .catch(function (error) {
          var message = (error && error.description) || 'Unable to add this item to cart.';
          itemsWrap.innerHTML = '<div class="bl-cartdrawer__state">' + escapeHtml(message) + '</div>';
          alert(message);
        })
        .finally(function () {
          state.internalAddActive = false;
          delete form.dataset.blCartSubmitting;
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.innerHTML = originalHtml;
          }
        });
    }

    function scheduleDrawerRefreshAndOpen(delay) {
      clearTimeout(state.autoOpenTimer);
      state.autoOpenTimer = setTimeout(function () {
        fetchCart(true);
      }, typeof delay === 'number' ? delay : 80);
    }

    function isCartTrigger(el) {
      if (!el) return false;
      if (el.closest('[data-bl-cart-ignore]')) return false;
      if (el.matches('[data-bl-cart-trigger], .js-bl-cart-trigger, .bl-header-cart-toggle, #cart-icon-bubble, .header__icon--cart')) return true;
      var cartLink = el.closest && el.closest('#cart-icon-bubble, .header__icon--cart');
      if (cartLink) return true;
      if (el.tagName === 'A') {
        var href = (el.getAttribute('href') || '').trim();
        if (href === '/cart' || href === config.cartUrl) return true;
        if (/\/cart(\?|$)/.test(href) && !/add/.test(href)) return true;
      }
      return false;
    }

    function isVariantOptionButton(el) {
      if (!el || !el.matches) return false;

      var text = String(el.textContent || el.value || el.getAttribute('aria-label') || el.getAttribute('data-value') || '').replace(/\s+/g, ' ').trim().toUpperCase();
      text = text.replace(/READY TO ADD|ADD TO CART|SOLD OUT|UNAVAILABLE/ig, '').trim();
      var sizeTextPattern = /^(XS|S|M|L|XL|XXL|XXXL|XXXXL|2XL|3XL|4XL|5XL|28|30|32|34|36|38|40|42|44|46)$/;

      if (sizeTextPattern.test(text)) return true;

      if (el.closest([
        'variant-radios',
        'variant-selects',
        '.product-form__input',
        '.product-form__option',
        '.product-form__variants',
        '.variant-picker',
        '.variant-picker__option',
        '.variant-picker__values',
        '.variant-input-wrap',
        '.variant-input',
        '.swatch',
        '.swatch-input__input',
        '.block-swatch',
        '.block-swatch-list',
        '.option-selector',
        '.selector-wrapper',
        '.product-option',
        '.size-selector',
        '.size-swatch',
        '.size-variant',
        '[data-option-position]',
        '[data-option-name]',
        '[data-option-value]',
        '[data-value]'
      ].join(','))) {
        return true;
      }

      return false;
    }

    function looksLikeAddToCartButton(el) {
      if (!el || !el.matches) return false;
      var text = String(el.textContent || el.value || '').replace(/\s+/g, ' ').trim().toUpperCase();
      if (/ADD\s*TO\s*CART|ADD\s*TO\s*BAG|ADD\s*TO\s*BASKET|BUY\s*NOW|SOLD\s*OUT|UNAVAILABLE/.test(text)) return true;
      return el.matches('[data-bl-cart-open-on-add], .product-form__add-button, .product-form__submit, .quick-add__submit, button[name="add"], input[name="add"], [data-action="add-to-cart"]');
    }

    function isVariantOnlyButton(el) {
      if (!el || !el.matches) return false;
      if (looksLikeAddToCartButton(el)) return false;
      return isVariantOptionButton(el);
    }

    function patchVariantButtons(scope) {
      var base = scope && scope.querySelectorAll ? scope : document;
      var buttons = base.querySelectorAll('button');
      buttons.forEach(function (button) {
        if (!isVariantOnlyButton(button)) return;
        if (!button.getAttribute('type') || String(button.getAttribute('type')).toLowerCase() === 'submit') {
          button.setAttribute('type', 'button');
        }
        button.setAttribute('data-bl-variant-option-button', 'true');
      });
    }

    function isAddToCartButton(el) {
      if (!el) return false;
      if (el.closest('[data-bl-cart-ignore]')) return false;
      if (el.matches('.button--disabled,[disabled]')) return false;
      if (isVariantOnlyButton(el)) return false;

      var isExplicitAddButton = looksLikeAddToCartButton(el);
      if (!isExplicitAddButton) return false;

      if (el.tagName === 'BUTTON') {
        var type = String(el.getAttribute('type') || 'submit').toLowerCase();
        if (type !== 'submit' && !el.matches('[data-bl-cart-open-on-add], .product-form__submit, .quick-add__submit, [data-action="add-to-cart"], button[name="add"]')) {
          return false;
        }
      }

      return true;
    }

    patchVariantButtons(document);
    try {
      var blVariantObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes && Array.prototype.forEach.call(mutation.addedNodes, function (node) {
            if (node && node.nodeType === 1) patchVariantButtons(node);
          });
        });
      });
      blVariantObserver.observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}


    /*
      Dawn / collection quick-size popup guard
      --------------------------------------------------
      Some quick-add popups render size choices as real buttons/inputs inside
      a cart form. Browsers treat plain <button> as submit, and some theme
      scripts close the quick popup on any delegated click/submit. This guard
      keeps size selection local and allows only the actual Add to Cart button
      to submit through this cart drawer script.
    */
    var BL_SIZE_TEXT_RE = /^(XS|S|M|L|XL|XXL|XXXL|XXXXL|2XL|3XL|4XL|5XL|28|30|32|34|36|38|40|42|44|46)$/;
    var blProductJsonCache = Object.create(null);

    function blCleanSizeText(text) {
      return String(text || '')
        .replace(/\s+/g, ' ')
        .replace(/READY TO ADD|ADD TO CART|SOLD OUT|UNAVAILABLE/ig, '')
        .trim()
        .toUpperCase();
    }

    function blGetChoiceText(el) {
      if (!el) return '';
      var text = '';
      if (el.matches && el.matches('input')) {
        text = el.getAttribute('data-value') || el.getAttribute('value') || el.getAttribute('aria-label') || el.getAttribute('title') || '';
        if (!text && el.id) {
          var label = document.querySelector('label[for="' + CSS.escape(el.id) + '"]');
          if (label) text = label.textContent || '';
        }
      } else {
        text = el.getAttribute('data-value') || el.getAttribute('data-option-value') || el.getAttribute('aria-label') || el.getAttribute('title') || el.textContent || el.value || '';
      }
      return blCleanSizeText(text);
    }

    function blIsSizeText(text) {
      return BL_SIZE_TEXT_RE.test(blCleanSizeText(text));
    }

    function blFindQuickSizeChoice(target) {
      if (!target || !target.closest) return null;
      var choice = target.closest('button, label, input, [data-value], [data-option-value], .block-swatch, .size-swatch, .size-variant, .variant-input, .variant-option, .swatch, .swatch__button');
      if (!choice) return null;

      var buttonOrInput = choice.closest('button, input[type="submit"], input[type="button"]');
      if (buttonOrInput && looksLikeAddToCartButton(buttonOrInput)) return null;

      var text = blGetChoiceText(choice);
      if (!blIsSizeText(text)) return null;

      var context = blFindQuickAddContext(choice);
      if (!context) return null;

      var contextText = blCleanSizeText(context.textContent || '');
      var hasSelectSizeUi = /SELECT SIZE|READY TO ADD|ADD TO CART/.test(contextText);
      var hasQuickClass = !!choice.closest('.quick-add, quick-add-modal, modal-dialog, .quick-add-modal, .quick-shop, .quickshop, .product-card, .product-item, .card-wrapper, .product-card-wrapper, .grid__item');
      if (!hasSelectSizeUi && !hasQuickClass) return null;

      return choice;
    }

    function blFindQuickAddContext(el) {
      if (!el || !el.closest) return null;
      return el.closest('.quick-add, quick-add-modal, modal-dialog, .quick-add-modal, .quick-shop, .quickshop, .product-card, .product-item, .product-card-wrapper, .card-wrapper, .grid__item, li, form') || el.closest('form');
    }

    function blFindCartForm(context, choice) {
      if (choice && choice.closest) {
        var ownForm = choice.closest('form');
        if (ownForm && ownForm.matches('form[action*="/cart/add"], form[action^="/cart/add"]')) return ownForm;
      }
      if (context && context.querySelector) {
        var form = context.querySelector('form[action*="/cart/add"], form[action^="/cart/add"]');
        if (form) return form;
      }
      return null;
    }

    function blNumericAttr(el, attrs) {
      if (!el || !el.getAttribute) return '';
      for (var i = 0; i < attrs.length; i += 1) {
        var raw = String(el.getAttribute(attrs[i]) || '').trim();
        if (/^\d{6,}$/.test(raw)) return raw;
      }
      return '';
    }

    function blExtractVariantId(choice) {
      var attrs = ['data-variant-id', 'data-variant', 'data-id', 'data-product-variant-id', 'data-variantid', 'value'];
      var fromChoice = blNumericAttr(choice, attrs);
      if (fromChoice) return fromChoice;
      var input = blGetLinkedInput(choice);
      var fromInput = blNumericAttr(input, attrs);
      if (fromInput) return fromInput;
      var nested = choice && choice.querySelector ? choice.querySelector('[data-variant-id], [data-variant], [data-id], [data-product-variant-id], input[value]') : null;
      return blNumericAttr(nested, attrs);
    }

    function blGetLinkedInput(choice) {
      if (!choice) return null;
      if (choice.matches && choice.matches('input')) return choice;
      if (choice.matches && choice.matches('label') && choice.htmlFor) {
        return document.getElementById(choice.htmlFor);
      }
      if (choice.querySelector) {
        return choice.querySelector('input[type="radio"], input[type="button"], input[type="submit"], input[name="id"]');
      }
      return null;
    }

    function blSetFormVariantId(form, variantId) {
      if (!form || !variantId) return;
      var idInput = form.querySelector('input[name="id"], select[name="id"]');
      if (!idInput) {
        idInput = document.createElement('input');
        idInput.type = 'hidden';
        idInput.name = 'id';
        form.appendChild(idInput);
      }
      idInput.value = String(variantId);
      idInput.setAttribute('value', String(variantId));
    }

    function blEnableAddButton(context, form) {
      var scope = context || form || document;
      if (!scope.querySelectorAll) return;
      scope.querySelectorAll('button, input[type="submit"], input[type="button"]').forEach(function (btn) {
        if (!looksLikeAddToCartButton(btn)) return;
        btn.disabled = false;
        btn.removeAttribute('disabled');
        btn.classList.remove('disabled', 'button--disabled');
        btn.setAttribute('aria-disabled', 'false');
      });
    }

    function blMarkSelectedSize(context, choice) {
      if (!context || !context.querySelectorAll || !choice) return;
      var choices = context.querySelectorAll('button, label, input, [data-value], [data-option-value], .block-swatch, .size-swatch, .size-variant, .variant-input, .variant-option, .swatch, .swatch__button');
      choices.forEach(function (node) {
        if (!blIsSizeText(blGetChoiceText(node))) return;
        node.classList.remove('is-selected', 'selected', 'active', 'is-active');
        node.removeAttribute('data-bl-size-selected');
        if (node.setAttribute) node.setAttribute('aria-pressed', 'false');
      });
      choice.classList.add('is-selected', 'selected', 'active');
      choice.setAttribute('data-bl-size-selected', 'true');
      choice.setAttribute('aria-pressed', 'true');

      var input = blGetLinkedInput(choice);
      if (input && input.matches && input.matches('input[type="radio"], input[type="checkbox"]')) {
        input.checked = true;
        input.setAttribute('checked', 'checked');
      }

      // Mirror selection to common quick-add option inputs without firing theme close handlers.
      var sizeText = blGetChoiceText(choice);
      if (context && context.querySelectorAll && sizeText) {
        context.querySelectorAll('input[name*="Size" i], input[name*="size" i], input[name*="option" i]').forEach(function (opt) {
          if (opt.type === 'hidden' || opt.type === 'text') {
            opt.value = sizeText;
            opt.setAttribute('value', sizeText);
          }
        });
      }
    }

    function blGetProductHandleFromContext(context) {
      if (!context) return '';
      var handle = '';
      if (context.getAttribute) {
        handle = context.getAttribute('data-product-handle') || context.getAttribute('data-handle') || '';
      }
      if (!handle && context.querySelector) {
        var link = context.querySelector('a[href*="/products/"]');
        if (link) {
          var href = link.getAttribute('href') || '';
          var match = href.match(/\/products\/([^\/?#]+)/);
          if (match) handle = match[1];
        }
      }
      return handle;
    }

    function blFetchProductJson(handle) {
      if (!handle) return Promise.resolve(null);
      if (blProductJsonCache[handle]) return blProductJsonCache[handle];
      var url = getShopRoot() + 'products/' + encodeURIComponent(handle) + '.js';
      blProductJsonCache[handle] = fetch(url, {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      }).then(function (res) {
        if (!res.ok) throw new Error('Product json failed');
        return res.json();
      }).catch(function () { return null; });
      return blProductJsonCache[handle];
    }

    function blResolveVariantId(context, sizeText) {
      var handle = blGetProductHandleFromContext(context);
      return blFetchProductJson(handle).then(function (product) {
        if (!product || !Array.isArray(product.variants)) return '';
        var size = blCleanSizeText(sizeText);
        var match = product.variants.find(function (variant) {
          var opts = [variant.option1, variant.option2, variant.option3].map(blCleanSizeText);
          return opts.indexOf(size) > -1 && variant.available !== false;
        }) || product.variants.find(function (variant) {
          var opts = [variant.option1, variant.option2, variant.option3].map(blCleanSizeText);
          return opts.indexOf(size) > -1;
        });
        return match && match.id ? String(match.id) : '';
      });
    }

    function blApplyQuickSizeChoice(choice) {
      var context = blFindQuickAddContext(choice);
      var form = blFindCartForm(context, choice);
      var sizeText = blGetChoiceText(choice);
      blMarkSelectedSize(context, choice);
      blEnableAddButton(context, form);

      var variantId = blExtractVariantId(choice);
      if (variantId) {
        blSetFormVariantId(form, variantId);
        return;
      }

      blResolveVariantId(context, sizeText).then(function (resolvedId) {
        if (resolvedId) {
          blSetFormVariantId(form, resolvedId);
          blEnableAddButton(context, form);
        }
      });
    }

    function blProtectQuickSizeEvent(event) {
      var choice = blFindQuickSizeChoice(event.target);
      if (!choice) return;

      // Run on WINDOW capture, before Dawn/custom quick-add delegated handlers on document/body.
      // This prevents the popup-close handler from seeing a size-selection click.
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    }

    function blHandleQuickSizeClick(event) {
      var choice = blFindQuickSizeChoice(event.target);
      if (!choice) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

      blApplyQuickSizeChoice(choice);
    }

    // Use window capture because many Shopify quick-add popups close from document/body delegated listeners.
    // Window capture runs before document capture.
    window.addEventListener('pointerdown', blProtectQuickSizeEvent, true);
    window.addEventListener('mousedown', blProtectQuickSizeEvent, true);
    window.addEventListener('touchstart', blProtectQuickSizeEvent, true);
    window.addEventListener('pointerup', blProtectQuickSizeEvent, true);
    window.addEventListener('mouseup', blProtectQuickSizeEvent, true);
    window.addEventListener('touchend', blProtectQuickSizeEvent, true);
    window.addEventListener('click', blHandleQuickSizeClick, true);


    // ===== Delivery pincode handlers ========================================
    // Validation strategy:
    //   1. Local regex /^[1-9][0-9]{5}$/ — quick reject for "000000" and junk
    //   2. India Post API (api.postalpincode.in) — verifies the pincode
    //      actually exists. Free, no auth, CORS-enabled. Only Indian pincodes
    //      are in the DB, so "ships only inside India" is enforced for free.
    // Manual entry only — no geolocation auto-detect.
    var PINCODE_STORAGE_KEY = 'blDeliveryPincodeV2';
    function blReadPincode() {
      try {
        var raw = localStorage.getItem(PINCODE_STORAGE_KEY);
        if (!raw) return null;
        var obj = JSON.parse(raw);
        if (!obj || !obj.pincode) return null;
        return obj;
      } catch (e) { return null; }
    }
    function blWritePincode(pincode, postOffice) {
      try {
        localStorage.setItem(PINCODE_STORAGE_KEY, JSON.stringify({
          pincode: pincode,
          district: (postOffice && postOffice.District) || '',
          state: (postOffice && postOffice.State) || '',
          ts: Date.now()
        }));
      } catch (e) {}
    }
    function blRenderDeliveryResult() {
      var scopes = [root].concat(Array.from(document.querySelectorAll('.bl-cart-extras')));
      var saved = blReadPincode();
      scopes.forEach(function (scope) {
        var pillEl   = scope.querySelector('[data-bl-delivery-open]');
        var resultEl = scope.querySelector('[data-bl-delivery-result]');
        if (!pillEl || !resultEl) return;
        if (saved && saved.pincode) {
          pillEl.hidden = true;
          var place = saved.district
            ? escapeHtml(saved.district) + (saved.state ? ', ' + escapeHtml(saved.state) : '') + ' — ' + escapeHtml(saved.pincode)
            : escapeHtml(saved.pincode);
          resultEl.hidden = false;
          resultEl.innerHTML = '<strong>Delivery in 4+ days</strong> to ' + place +
            ' <a href="#" data-bl-delivery-open>Change</a>';
        } else {
          pillEl.hidden = false;
          resultEl.hidden = true;
          resultEl.innerHTML = '';
          var labelEl = pillEl.querySelector('.bl-cartdrawer__delivery-label');
          var ctaEl   = pillEl.querySelector('.bl-cartdrawer__delivery-cta');
          if (labelEl) labelEl.textContent = 'Check Delivery';
          if (ctaEl)   ctaEl.textContent   = 'ENTER PIN CODE';
        }
      });
    }
    function blSetPincodeMsg(level, html) {
      var msg = root.querySelector('[data-bl-pincode-msg]');
      if (!msg) return;
      msg.hidden = false;
      msg.className = 'bl-cartdrawer__pincode-msg bl-cartdrawer__pincode-msg--' + level;
      if (level === 'info') {
        msg.innerHTML = '<span class="bl-cartdrawer__pincode-spinner" aria-hidden="true"></span>' + html;
      } else {
        msg.innerHTML = html;
      }
    }
    function blOpenPincodeSheet() {
      var overlay = root.querySelector('[data-bl-pincode-overlay]');
      var input   = root.querySelector('[data-bl-pincode-input]');
      var msg     = root.querySelector('[data-bl-pincode-msg]');
      if (!overlay) return;
      overlay.hidden = false;
      if (msg) { msg.hidden = true; msg.innerHTML = ''; msg.className = 'bl-cartdrawer__pincode-msg'; }
      var saved = blReadPincode();
      if (input) {
        input.value = (saved && saved.pincode) || '';
        setTimeout(function () { input.focus(); }, 50);
      }
    }
    function blClosePincodeSheet() {
      var overlay = root.querySelector('[data-bl-pincode-overlay]');
      if (overlay) overlay.hidden = true;
    }
    function blCheckPincode() {
      var input = root.querySelector('[data-bl-pincode-input]');
      var btn   = root.querySelector('[data-bl-pincode-check]');
      if (!input) return;
      var raw = String(input.value || '').trim();
      if (!raw) { blSetPincodeMsg('err', 'Please enter your pincode.'); return; }
      // Indian pincodes are pure digits; any letter means a foreign postal code.
      if (/[A-Za-z]/.test(raw)) {
        blSetPincodeMsg('err', 'Sorry, this item is not delivered outside India.');
        return;
      }
      var val = raw.replace(/\D/g, '');
      // A valid Indian pincode is exactly 6 digits and cannot start with 0.
      if (!/^[1-9][0-9]{5}$/.test(val)) {
        blSetPincodeMsg('err', 'The pincode you entered is wrong. Please enter a valid 6-digit Indian pincode.');
        return;
      }
      blSetPincodeMsg('info', 'Checking availability…');
      if (btn) btn.disabled = true;
      // Delivery is shown ONLY on a positive India Post match. If the API is slow
      // or unreachable we ask the customer to retry — we never assume serviceable.
      var done = false;
      function fail(html) {
        if (done) return; done = true;
        if (btn) btn.disabled = false;
        blSetPincodeMsg('err', html);
      }
      var timeoutId = setTimeout(function () {
        fail('Could not verify your pincode right now. Please check your connection and try again.');
      }, 8000);
      fetch('https://api.postalpincode.in/pincode/' + encodeURIComponent(val))
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (done) return;
          clearTimeout(timeoutId);
          var rec = Array.isArray(data) ? data[0] : null;
          var pos = rec && Array.isArray(rec.PostOffice) ? rec.PostOffice[0] : null;
          // API reachable but pincode not found in India => not a real Indian pincode.
          if (!rec || rec.Status !== 'Success' || !pos) {
            fail('The pincode you entered is wrong. Please check and try again.');
            return;
          }
          if (pos.Country && String(pos.Country).toLowerCase() !== 'india') {
            fail('Sorry, this item is not delivered outside India.');
            return;
          }
          done = true;
          if (btn) btn.disabled = false;
          blWritePincode(val, pos);
          blSetPincodeMsg('ok',
            '<strong>Delivery in 4+ days</strong> to ' + escapeHtml(pos.District) +
            ', ' + escapeHtml(pos.State) + '.');
          blRenderDeliveryResult();
          setTimeout(blClosePincodeSheet, 1100);
        })
        .catch(function () {
          clearTimeout(timeoutId);
          fail('Could not verify your pincode right now. Please check your connection and try again.');
        });
    }
    try { blRenderDeliveryResult(); } catch (e) {}
    // ===== end Delivery pincode handlers ====================================

    document.addEventListener('click', function (event) {
      var closeTarget = event.target.closest('[data-bl-cart-close]');
      if (closeTarget) {
        event.preventDefault();
        closeDrawer();
        return;
      }

      // Delivery pincode delegated handlers
      if (event.target.closest('[data-bl-delivery-open]')) {
        event.preventDefault();
        blOpenPincodeSheet();
        return;
      }
      if (event.target.closest('[data-bl-pincode-close]')) {
        event.preventDefault();
        blClosePincodeSheet();
        return;
      }
      if (event.target.closest('[data-bl-pincode-check]')) {
        event.preventDefault();
        blCheckPincode();
        return;
      }
      // Click on backdrop (overlay itself, not the sheet) closes
      if (event.target.matches('[data-bl-pincode-overlay]')) {
        event.preventDefault();
        blClosePincodeSheet();
        return;
      }

      var checkoutTarget = event.target.closest('[data-bl-cart-checkout]');
      if (checkoutTarget) {
        event.preventDefault();
        event.stopPropagation();
        if (checkoutTarget.disabled) return;
        var checkoutUrl = checkoutTarget.getAttribute('data-checkout-url') || config.checkoutUrl;
        window.location.href = checkoutUrl;
        return;
      }

      var trigger = event.target.closest('a, button');
      if (isCartTrigger(trigger)) {
        event.preventDefault();
        fetchCart(true);
        return;
      }

      var qtyButton = event.target.closest('.bl-cartdrawer__qty-btn');
      if (qtyButton) {
        event.preventDefault();
        event.stopPropagation();
        var item = qtyButton.closest('.bl-cartdrawer__item');
        if (!item) return;
        var key = item.getAttribute('data-key');
        var currentQty = parseInt((item.querySelector('.bl-cartdrawer__qty-value') || {}).textContent || '1', 10);
        var action = qtyButton.getAttribute('data-qty-action');
        // Stock validation is server-side — Shopify's /cart/change.js will
        // return an error (with a helpful "description") if the customer
        // tries to exceed available inventory. updateByKey() handles it.
        var nextQty = action === 'minus' ? currentQty - 1 : currentQty + 1;
        if (nextQty < 0) nextQty = 0;
        updateByKey(key, nextQty);
        return;
      }

      var removeButton = event.target.closest('[data-remove-item]');
      if (removeButton) {
        event.preventDefault();
        event.stopPropagation();
        var removeItem = removeButton.closest('.bl-cartdrawer__item');
        if (!removeItem) return;
        var removeKey = removeItem.getAttribute('data-key');
        updateByKey(removeKey, 0);
      }
    }, true);

    document.addEventListener('click', function (event) {
      var button = event.target.closest('button, input[type="submit"], input[type="button"]');
      if (!button) return;

      if (isVariantOnlyButton(button)) {
        // Important for Dawn/quick-add size popup:
        // Size buttons can be plain <button> elements, which default to submit.
        // Cancel only the default submit, but DO NOT stop propagation, so the theme can still select the size.
        event.preventDefault();
        patchVariantButtons(button.closest('form') || document);
        return;
      }

      if (!isAddToCartButton(button)) return;
      var form = findAddToCartForm(button);
      if (!form) return;
      if (form.hasAttribute('data-bl-cart-ignore')) return;
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      addToCart(form, button);
    }, true);

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches('form[action*="/cart/add"], form[action^="/cart/add"]')) return;
      if (form.hasAttribute('data-bl-cart-ignore')) return;

      var submitter = event.submitter || document.activeElement;
      if (submitter && isVariantOnlyButton(submitter)) {
        // Prevent quick-add popup closing when user is only choosing a size.
        event.preventDefault();
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      addToCart(form);
    }, true);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        var pincodeOverlay = root.querySelector('[data-bl-pincode-overlay]');
        if (pincodeOverlay && !pincodeOverlay.hidden) {
          blClosePincodeSheet();
          return;
        }
        if (root.classList.contains('is-open')) closeDrawer();
        return;
      }
      if (event.key === 'Enter' && event.target && event.target.matches('[data-bl-pincode-input]')) {
        event.preventDefault();
        blCheckPincode();
      }
    });

    if (window.fetch && !window.__BL_CART_FETCH_PATCHED__) {
      window.__BL_CART_FETCH_PATCHED__ = true;
      var nativeFetch = window.fetch;
      window.fetch = function () {
        var fetchUrl = arguments[0];
        var isAddRequest = isCartAddUrl(fetchUrl);
        return nativeFetch.apply(this, arguments).then(function (response) {
          if (isAddRequest && response && response.ok && !state.internalAddActive) {
            scheduleDrawerRefreshAndOpen(80);
          }
          return response;
        });
      };
    }

    if (window.XMLHttpRequest && !window.__BL_CART_XHR_PATCHED__) {
      window.__BL_CART_XHR_PATCHED__ = true;
      var nativeOpen = XMLHttpRequest.prototype.open;
      var nativeSend = XMLHttpRequest.prototype.send;

      XMLHttpRequest.prototype.open = function (method, url) {
        this.__blCartAddRequest = isCartAddUrl(url);
        return nativeOpen.apply(this, arguments);
      };

      XMLHttpRequest.prototype.send = function () {
        if (this.__blCartAddRequest) {
          this.addEventListener('load', function () {
            if (this.status >= 200 && this.status < 300 && !state.internalAddActive) {
              scheduleDrawerRefreshAndOpen(80);
            }
          });
        }
        return nativeSend.apply(this, arguments);
      };
    }

    window.BLThemeCartDrawer = {
      open: function () {
        // 2026-06-01 PERF: open instantly (CSS), then load cart content async.
        // Previously fetchCart(true) waited for the /cart.js network round-trip
        // before the drawer appeared, causing a 1-3s perceived lag on open.
        openDrawer();
        setLoading('Loading your cart...');
        fetchCart(false);
      },
      close: closeDrawer,
      refresh: function () { fetchCart(false); },
      addToCartForm: addToCart
    };

    renderBenefits();
    fetchCart(false);
  });
})();
